import React, { useEffect, useState } from 'react';
import {
  computeMainScoresSync,
  computeVitaminBScoresSync,
  computeNeurotransmitterScoresSync,
  computeMetabolitesScoresSync,
  computeMacronutrientScoresSync,
} from '../../utils/computePdfScores';
import './PdfStaticModal.css';
import { diseases, diseases_image} from '../../configs/pdfOverlayConfig';
import { scoreConfig_AllergyandEczema} from '../../configs/pdfScoreConfig';
import { image_size_qpt } from '../../configs/pdfTextConfig';
import { symbol_status, symbol_status_thai } from '../../configs/pdfcwConfig';
import { 
  supplement_images_eng, 
  supplement_images_thai 
} from '../../configs/supplement/qpt_supplement';
import axios from 'axios';
import { bacteriaLayoutConfig } from '../../configs/pdfBar_calculate';
import { 
  bacteriaMetaConfig,
  bacteriaMetaConfig_9P,
  bacteriaMetaConfig_allergy,
  bacteriaMetaConfig_toxin,
  bacteriaMetaConfig_oms,
  bacteriaMetaConfig_bwcallergy,
  bacteriaMetaConfig_bwccore,
  bacteriaMetaConfig_bwcdiamond,
  bacteriaMetaConfig_allergy_kids
} from '../../configs/calculate_ctvalue';
import { evaluateBacteriaCondition } from '../../utils/bacteriaEvaluator';
import { FONT_STACK_MIXED_THAI_LATIN } from '../../utils/fontStacks';
import { scoreLabelMappingThai, scoreLabelPositionThai} from '../../configs/thai/pdfBar_calculate_thai';
import { vitaminB_sp, vitaminB_multi, vitaminB_spCondition, vitaminB_spCondition_thai } from '../../configs/extraresult/vitaminsBConfig';
import { neurotransmitter_sp, neurotransmitter_multi, neurotransmitter_spCondition, neurotransmitter_spCondition_thai } from '../../configs/extraresult/neurotransmitterConfig';
import { metabolites_sp, metabolites_multi, metabolites_spCondition, metabolites_spCondition_thai } from '../../configs/extraresult/metabolitesConfig';
import { macronutrient_sp, macronutrient_multi, macronutrient_harmfulsp, macronutrientharmful_multi, macronutrient_spCondition, macronutrient_spCondition_thai } from '../../configs/extraresult/macronutrientConfig';
import { scoreConfig_AllergyandEczema_thai } from '../../configs/thai/pdfScore_thai';
import { diseases_image_thai, diseases_thai } from '../../configs/thai/pdficonConfig_thai';
import imageOverlayConfig from '../../configs/All_formatConfig/Config_image';
import {
  pdfOverlayConfigPersonal,
  pdfOverlayConfigPersonal_9P, 
  pdfOverlayConfigPersonal_allergy, 
  pdfOverlayConfigPersonal_toxin, 
  pdfOverlayConfigPersonal_oms,
  pdfOverlayConfigPersonal_bwcallergy,
  pdfOverlayConfigPersonal_bwccore,
  pdfOverlayConfigPersonal_bwcdiamond,
  pdfOverlayConfigPersonal_allergy_kids,
} from '../../configs/All_formatConfig/Config_personal';

import {
  bacteriaLayoutConfig_9P_eng,
  bacteriaLayoutConfig_9P_thai
} from '../../configs/9P/Config_barcolor_9P';

import { scoreConfig_AllergyandEczema_9P } from '../../configs/9P/pdfScoreConfig_9P';
import { diseases_9P_eng, diseases_9P_thai, diseases_image_9P_eng, diseases_image_9P_thai } from '../../configs/9P/Config_icondysis_9P';
import { symbol_status_9P_eng, symbol_status_9P_thai, width_9P } from '../../configs/9P/Config_checkbox_9P';

import {
  bacteriaLayoutConfig_allergy_eng,
  bacteriaLayoutConfig_allergy_thai
} from '../../configs/allergy/Config_barcolor_allergy';

import {
  bacteriaLayoutConfig_allergy_kids_eng,
  bacteriaLayoutConfig_allergy_kids_thai
} from '../../configs/allergy_kids/Config_barcolor_allergy_kids';

import { scoreConfig_AllergyandEczema_allergy } from '../../configs/allergy/pdfScoreConfig_allergy';
import { scoreConfig_AllergyandEczema_allergy_kids, typeofbacteria_qpt_kids } from '../../configs/allergy_kids/pdfScoreConfig_allergy_kids';
import { scoreConfig_AllergyandEczema_toxin, typeofbacteria_toxin } from '../../configs/Toxin/pdfScoreConfig_toxin';
import { scoreConfig_AllergyandEczema_oms, typeofbacteria_oms } from '../../configs/oms/pdfScoreConfig_oms';
import { scoreConfig_AllergyandEczema_bwcallergy, typeofbacteria_bwcallergy } from '../../configs/bwc_allergy/pdfScoreConfig_bwcallergy';
import { scoreConfig_AllergyandEczema_bwccore, typeofbacteria_bwccore } from '../../configs/bwc_core/pdfScoreConfig_bwccore';

import {
  diseases_allergy_eng,
  diseases_allergy_thai,
  diseases_image_allergy_eng,
  diseases_image_allergy_thai
} from '../../configs/allergy/Config_icondysis_allergy';

import {
  diseases_oms_eng,
  diseases_oms_thai,
  diseases_image_oms_eng,
  diseases_image_oms_thai
} from '../../configs/oms/Config_icondysis_oms';

import { symbol_status_allergy, symbol_status_thai_allergy } from '../../configs/allergy/Config_checkbox_allergy';
import { symbol_status_allergy_kids, symbol_status_thai_allergy_kids } from '../../configs/allergy_kids/Config_checkbox_allergy_kids';

import {
  diseases_allergy_kids_eng,
  diseases_allergy_kids_thai,
  diseases_image_allergy_kids_eng,
  diseases_image_allergy_kids_thai
} from '../../configs/allergy_kids/Config_icondysis_allergy_kids';

import {
  bacteriaLayoutConfig_toxin_eng,
  bacteriaLayoutConfig_toxin_thai
} from '../../configs/Toxin/Config_barcolor_toxin';

import {
  diseases_toxin_eng,
  diseases_toxin_thai,
  diseases_image_toxin_eng,
  diseases_image_toxin_thai
} from '../../configs/Toxin/Config_icondysis_toxin';

import {
  diseases_bwcallergy_eng,
  diseases_bwcallergy_thai,
  diseases_image_bwcallergy_eng,
  diseases_image_bwcallergy_thai
} from '../../configs/bwc_allergy/Config_icondysis_bwcallergy';

import {
  diseases_bwccore_eng,
  diseases_bwccore_thai,
  diseases_image_bwccore_eng,
  diseases_image_bwccore_thai
} from '../../configs/bwc_core/Config_icondysis_bwccore';

import {
  diseases_bwcdiamond_eng,
  diseases_bwcdiamond_thai,
  diseases_image_bwcdiamond_eng,
  diseases_image_bwcdiamond_thai
} from '../../configs/bwc_diamond/Config_icondysis_bwcdiamond';

import { symbol_status_oms, width_oms } from '../../configs/oms/Config_checkbox_oms';
import { symbol_status_bwcallergy_eng, symbol_status_bwcallergy_thai, width_bwcallergy } from '../../configs/bwc_allergy/Config_checkbox_bwcallergy';
import { symbol_status_bwccore_eng, symbol_status_bwccore_thai, width_bwccore } from '../../configs/bwc_core/Config_checkbox_bwccore';
import { width_bwcdiamond } from '../../configs/bwc_diamond/Config_checkbox_bwcdiamond';
import { symbol_status_bwcdiamond_eng, symbol_status_bwcdiamond_thai } from '../../configs/bwc_diamond/Config_checkbox_bwcdiamond';
import { symbol_status_toxin_eng, symbol_status_toxin_thai, width_toxin } from '../../configs/Toxin/Config_checkbox_toxin';

import {
  bacteriaLayoutConfig_oms_eng,
  bacteriaLayoutConfig_oms_thai
} from '../../configs/oms/Config_barcolor_oms';

import {
  bacteriaLayoutConfig_bwcallergy_eng,
  bacteriaLayoutConfig_bwcallergy_thai
} from '../../configs/bwc_allergy/Config_barcolor_bwcallergy';

import {
  bacteriaLayoutConfig_bwccore_eng,
  bacteriaLayoutConfig_bwccore_thai
} from '../../configs/bwc_core/Config_barcolor_bwccore';

import {
  bacteriaLayoutConfig_bwcdiamond_eng,
  bacteriaLayoutConfig_bwcdiamond_thai
} from '../../configs/bwc_diamond/Config_barcolor_bwcdiamond';

// import number page insert section
import { 
  qpt_numberpage_eng,
  qpt_numberpage_thai,
  NineP_numberpage_eng,
  NineP_numberpage_thai,
  as_numberpage_eng,
  as_numberpage_thai,
  toxin_numberpage_eng,
  toxin_numberpage_thai,
  oms_numberpage_eng,
  oms_numberpage_thai,
  bwcallergy_numberpage_eng,
  bwcallergy_numberpage_thai,
  bwccore_numberpage_eng,
  bwccore_numberpage_thai,
  bwcdiamond_numberpage_eng,
  bwcdiamond_numberpage_thai
} from '../../configs/pdfnumberpageConfig';

import {
  supplement_images9P_eng,
  supplement_images9P_thai,
  supplement_images9P_eng_old,
  supplement_images9P_thai_old
} from '../../configs/supplement/9P_supplement';
import Supplement9PCard from './Supplement9PCard';
import { typeofbacteria_qpt } from '../../configs/pdfScoreConfig';
import { typeofbacteria_qpt as typeofbacteria_qpt_allergy } from '../../configs/allergy/pdfScoreConfig_allergy';
import { typeofbacteria_9P } from '../../configs/9P/pdfScoreConfig_9P';
import { choosing_supplement_9P, choosing_supplement_9P_old, addBioGraceIfNeeded_old } from '../../configs/supplement/9P_supplement';
import { choosing_supplement_AMG } from '../../configs/supplement/AMG_supplement';
import { choosing_supplement_toxin } from '../../configs/supplement/toxin_supplement';
import { choosing_supplement_bwc, choosing_supplement_bwcdiamond, supplement_images_bwcdiamond_eng, supplement_images_bwcdiamond_thai } from '../../configs/supplement/bwc_supplement';
import { choosing_supplement as qpt_choosing_supplement } from '../../configs/supplement/qpt_supplement';
import { choosing_supplement_oms } from '../../configs/supplement/oms_supplement';
import { getRecommendedSupplements, set9PSupplementVersion, panelSupportsNewFormula } from '../../pages/calculate_selection';
import { text_config as pdfTextConfig } from '../../configs/pdfTextConfig';
import { text_config_thai as pdfTextConfig_thai } from '../../configs/thai/pdfTextConfig_thai';
import { text_all_qpt, reportnumber_all_qpt, reportnumber_all_9P, reportnumber_all_allergy, reportnumber_all_allergy_kids, reportnumber_all_toxin, reportnumber_all_oms } from '../../configs/All_formatConfig/Config_textall';
import { text_allpage_bwcdiamond_eng, text_allpage_bwcdiamond_thai } from '../../configs/bwc_diamond/Config_textallpage_bwcdiamond';
import { text_allpage_bwcallergy_eng, text_allpage_bwcallergy_thai } from '../../configs/bwc_allergy/Config_textallpage_bwcallergy';
import { text_allpage_bwccore_eng, text_allpage_bwccore_thai } from '../../configs/bwc_core/Config_textallpage_bwccore';
import { 
  getScoringLevel as getScoringLevelQPT, 
  calculateOverallScore as calculateOverallScoreQPT, 
  shouldShowScoringLevel as shouldShowScoringLevelQPT,
  getScoringDisplayConfig as getScoringDisplayConfigQPT 
} from '../../configs/pdfCallevelConfig.js';

// Import the new precise text configuration
import { 
  getDeficientBacteriaNames, 
  formatBacteriaNames, 
  getTextConfigForPage,
  pdfTextPreciseConfig
} from '../../configs/pdftextpreciseConfig.js';

// Import allergy-specific precise text configuration
import { 
  getDeficientBacteriaNames as getDeficientBacteriaNamesAllergy, 
  formatBacteriaNames as formatBacteriaNamesAllergy, 
  getTextConfigForPage as getTextConfigForPageAllergy,
  pdfTextPreciseConfig_allergy
} from '../../configs/allergy/pdftextpreciseConfig_allergy.js';

// Import allergy kids precise text configuration
import { 
  getDeficientBacteriaNames as getDeficientBacteriaNamesAllergyKids, 
  formatBacteriaNames as formatBacteriaNamesAllergyKids, 
  getTextConfigForPage as getTextConfigForPageAllergyKids,
  pdfTextPreciseConfig_allergy_kids
} from '../../configs/allergy_kids/pdftextpreciseConfig_allergy_kids.js';

// Import BWC Diamond precise text configuration
import { 
  getDeficientBacteriaNames as getDeficientBacteriaNamesDiamond, 
  formatBacteriaNames as formatBacteriaNamesDiamond, 
  getTextConfigForPage as getTextConfigForPageDiamond,
  pdfTextPreciseConfig_diamond
} from '../../configs/bwc_diamond/pdftextpreciseConfig_diamond.js';

// Import BWC Allergy precise text configuration
import { 
  getDeficientBacteriaNames as getDeficientBacteriaNamesBwcallergy, 
  formatBacteriaNames as formatBacteriaNamesBwcallergy, 
  getTextConfigForPage as getTextConfigForPageBwcallergy,
  pdfTextPreciseConfig_bwcallergy
} from '../../configs/bwc_allergy/pdftextpreciseConfig_bwcallergy.js';

// Import BWC Core precise text configuration
import { 
  getDeficientBacteriaNames as getDeficientBacteriaNamesBwccore, 
  formatBacteriaNames as formatBacteriaNamesBwccore, 
  getTextConfigForPage as getTextConfigForPageBwccore,
  pdfTextPreciseConfig_bwccore
} from '../../configs/bwc_core/pdftextpreciseConfig_bwccore.js';

// Import scoring level configurations based on report mode
import { 
  getScoringLevel as getScoringLevelAllergy, 
  calculateOverallScore as calculateOverallScoreAllergy, 
  shouldShowScoringLevel as shouldShowScoringLevelAllergy,
  getScoringDisplayConfig as getScoringDisplayConfigAllergy 
} from '../../configs/allergy/pdfCallevelConfig_allergy.js';

import { 
  getScoringLevel as getScoringLevelAllergyKids, 
  calculateOverallScore as calculateOverallScoreAllergyKids, 
  shouldShowScoringLevel as shouldShowScoringLevelAllergyKids,
  getScoringDisplayConfig as getScoringDisplayConfigAllergyKids 
} from '../../configs/allergy_kids/pdfCallevelConfig_allergy_kids.js';

import {
  typeofbacteria_bwcdiamond, scoreConfig_AllergyandEczema_bwcdiamond
} from '../../configs/bwc_diamond/pdfScoreConfig_bwcdiamond';

// Import BWC Diamond scoring level configuration
import { 
  getScoringLevel as getScoringLevelBwcdiamond, 
  calculateOverallScore as calculateOverallScoreBwcdiamond, 
  shouldShowScoringLevel as shouldShowScoringLevelBwcdiamond,
  getScoringDisplayConfig as getScoringDisplayConfigBwcdiamond 
} from '../../configs/bwc_diamond/pdfCallevelConfig_bwcdiamond.js';

// Import BWC Allergy scoring level configuration
import { 
  getScoringLevel as getScoringLevelBwcallergy, 
  calculateOverallScore as calculateOverallScoreBwcallergy, 
  shouldShowScoringLevel as shouldShowScoringLevelBwcallergy,
  getScoringDisplayConfig as getScoringDisplayConfigBwcallergy 
} from '../../configs/bwc_allergy/pdfCallevelConfig_bwcallergy.js';

// Import BWC Core scoring level configuration
import { 
  getScoringLevel as getScoringLevelBwccore, 
  calculateOverallScore as calculateOverallScoreBwccore, 
  shouldShowScoringLevel as shouldShowScoringLevelBwccore,
  getScoringDisplayConfig as getScoringDisplayConfigBwccore 
} from '../../configs/bwc_core/pdfCallevelConfig_bwccore.js';

// Import 9P scoring level configuration
import { 
  getScoringLevel as getScoringLevel9P, 
  calculateOverallScore as calculateOverallScore9P, 
  shouldShowScoringLevel as shouldShowScoringLevel9P,
  getScoringDisplayConfig as getScoringDisplayConfig9P 
} from '../../configs/9P/pdfCallevelConfig_9P.js';

// Import 9P precise text config and helpers
import {
  pdfTextPreciseConfig_9P,
  getDeficientBacteriaNames as getDeficientBacteriaNames9P,
  formatBacteriaNames as formatBacteriaNames9P,
  getTextConfigForPage as getTextConfigForPage9P
} from '../../configs/9P/pdftextpreciseConfig_9P';

// Import 9P macronutrient summary section (page 19 eng / page 20 thai)
import { calculateMacronutrient9P } from '../../configs/9P/Config_macronutrient';

// Import 9P vitamin B biosynthesis summary section (page 20 eng / page 19 thai)
import { calculateVitaminB9P } from '../../configs/9P/Config_vitamin_b_biosynthesis';

// Import 9P SCFAs summary section (page 21 eng / page 20 thai)
import { calculateScfas9P } from '../../configs/9P/Config_SCFAs';

// Import 9P Neurotransmitter summary section (page 22 eng / page 21 thai)
import { calculateNeurotransmitter9P } from '../../configs/9P/Config_Neurotransmitter';

// Import OMS scoring level configuration
import { 
  getScoringLevel as getScoringLevelOms, 
  calculateOverallScore as calculateOverallScoreOms, 
  shouldShowScoringLevel as shouldShowScoringLevelOms,
  getScoringDisplayConfig as getScoringDisplayConfigOms 
} from '../../configs/oms/pdfCallevelConfig_oms.js';

// Import OMS precise text configuration
import { 
  getDeficientBacteriaNames as getDeficientBacteriaNamesOms, 
  formatBacteriaNames as formatBacteriaNamesOms, 
  getTextConfigForPage as getTextConfigForPageOms,
  pdfTextPreciseConfig_oms
} from '../../configs/oms/pdftextpreciseConfig_oms.js';

// Import Toxin precise text configuration
import { 
  getDeficientBacteriaNames as getDeficientBacteriaNamesToxin, 
  formatBacteriaNames as formatBacteriaNamesToxin, 
  getTextConfigForPage as getTextConfigForPageToxin,
  pdfTextPreciseConfig_toxin
} from '../../configs/Toxin/pdftextpreciseConfig_toxin.js';

// Helper functions to get the appropriate scoring functions based on report mode
const getScoringFunctions = (reportMode) => {
  if (reportMode === '9P') {
    return {
      getScoringLevel: getScoringLevel9P,
      calculateOverallScore: calculateOverallScore9P,
      shouldShowScoringLevel: shouldShowScoringLevel9P,
      getScoringDisplayConfig: getScoringDisplayConfig9P
    };
  } else if (reportMode === 'Allergy and Skin') {
    return {
      getScoringLevel: getScoringLevelAllergy,
      calculateOverallScore: calculateOverallScoreAllergy,
      shouldShowScoringLevel: shouldShowScoringLevelAllergy,
      getScoringDisplayConfig: getScoringDisplayConfigAllergy
    };
  } else if (reportMode === 'Allergy and Skin_kids') {
    return {
      getScoringLevel: getScoringLevelAllergyKids,
      calculateOverallScore: calculateOverallScoreAllergyKids,
      shouldShowScoringLevel: shouldShowScoringLevelAllergyKids,
      getScoringDisplayConfig: getScoringDisplayConfigAllergyKids
    };
  } else if (reportMode === 'Toxin') {
    // Toxin uses QPT scoring functions
    return {
      getScoringLevel: getScoringLevelQPT,
      calculateOverallScore: calculateOverallScoreQPT,
      shouldShowScoringLevel: shouldShowScoringLevelQPT,
      getScoringDisplayConfig: getScoringDisplayConfigQPT
    };
  } else if (reportMode === 'oms') {
    return {
      getScoringLevel: getScoringLevelOms,
      calculateOverallScore: calculateOverallScoreOms,
      shouldShowScoringLevel: shouldShowScoringLevelOms,
      getScoringDisplayConfig: getScoringDisplayConfigOms
    };
  } else if (reportMode === 'bwcallergy') {
    return {
      getScoringLevel: getScoringLevelBwcallergy,
      calculateOverallScore: calculateOverallScoreBwcallergy,
      shouldShowScoringLevel: shouldShowScoringLevelBwcallergy,
      getScoringDisplayConfig: getScoringDisplayConfigBwcallergy
    };
  } else if (reportMode === 'bwccore') {
    return {
      getScoringLevel: getScoringLevelBwccore,
      calculateOverallScore: calculateOverallScoreBwccore,
      shouldShowScoringLevel: shouldShowScoringLevelBwccore,
      getScoringDisplayConfig: getScoringDisplayConfigBwccore
    };
  } else if (reportMode === 'bwcdiamond') {
    return {
      getScoringLevel: getScoringLevelBwcdiamond,
      calculateOverallScore: calculateOverallScoreBwcdiamond,
      shouldShowScoringLevel: shouldShowScoringLevelBwcdiamond,
      getScoringDisplayConfig: getScoringDisplayConfigBwcdiamond
    };
  } else {
    // Default to QPT for all other formats
    return {
      getScoringLevel: getScoringLevelQPT,
      calculateOverallScore: calculateOverallScoreQPT,
      shouldShowScoringLevel: shouldShowScoringLevelQPT,
      getScoringDisplayConfig: getScoringDisplayConfigQPT
    };
  }
};

// Helper function to get the appropriate bacteria type configuration based on report mode
const getTypeofBacteriaQpt = (reportMode) => {
  if (reportMode === '9P') {
    return typeofbacteria_9P;
  } else if (reportMode === 'Allergy and Skin') {
    return typeofbacteria_qpt_allergy;
  } else if (reportMode === 'Allergy and Skin_kids') {
    return typeofbacteria_qpt_kids;
  } else if (reportMode === 'Toxin') {
    return typeofbacteria_toxin;
  } else if (reportMode === 'oms') {
    return typeofbacteria_oms;
  } else if (reportMode === 'bwcallergy') {
    return typeofbacteria_bwcallergy;
  } else if (reportMode === 'bwccore') {
    return typeofbacteria_bwccore;
  } else if (reportMode === 'bwcdiamond') {
    return typeofbacteria_bwcdiamond;
  } else {
    // Default to QPT for all other formats
    return typeofbacteria_qpt;
  }
};

// Maximum number of recommended supplements shown on the 9P supplement page.
const MAX_9P_SUPPLEMENTS = 9;

// Quick Navigation jump targets, per report mode. English and Thai page numbers
// are listed separately because the 9P Thai booklet is not a fixed offset from
// the English one (e.g. the supplement page is 15 eng / 14 thai).
// Add more entries here to extend the panel.
const QUICK_NAV_PAGES = {
  '9P': [
    { text: 'Your Microbiome Profile Summary', page_eng: 12, page_thai: 11 },
    { text: 'Probiotics supplement advice', page_eng: 15, page_thai: 14 }
  ]
};

// Fixed grid layout for the 9P "Supplement Facts" cards.
// The new 9P formula returns one single-strain SKU per deficient species. The
// grid is ALWAYS a 3-column layout sized as though the page were full (3x3), so
// every card is identical in size no matter how many appear on a page โ€” a page
// with 4 spilled cards matches the page with 9 before it. Cards fill the columns
// left-to-right and the block stays centred on the page.
//
// Both the width and the ROW HEIGHT are fixed here, and the card is rendered at
// exactly `rowHeight` (see Supplement9PCard's `height` prop). Nothing about the
// layout depends on how tall a card's text happens to be, so three rows always
// fit on the page.
//
// ---- TUNING ----
// * CARD_MAX_WIDTH  -> upper bound on card (and therefore text) size.
// * USABLE_HEIGHT   -> vertical room below the container top (y=100). This is the
//                      only knob for card height: lower it if the cards overlap
//                      content further down the supplement page, raise it if the
//                      page has more free space.
const get9PSupplementGridLayout = (count) => {
  const USABLE_WIDTH = 744;    // A4 width (794) minus the left/right margin at x=25
  const USABLE_HEIGHT = 950;   // free space below the page title (y=100 .. ~1050)
  const GAP = 26;              // spacing between cards (clears the stick overhang)
  const CARD_MAX_WIDTH = 360;  // cap so a card is never absurdly large

  const COLUMNS = 3;           // always three columns
  const SIZING_ROWS = 3;       // always sized for a full 3x3 page

  const n = Math.max(1, Math.min(count, MAX_9P_SUPPLEMENTS));

  // Width and height are both constant: derived from a full 3x3 page, never
  // from `count` and never from the rendered content.
  const cardWidth = Math.floor(Math.min((USABLE_WIDTH - GAP * (COLUMNS - 1)) / COLUMNS, CARD_MAX_WIDTH));
  const rowHeight = Math.floor((USABLE_HEIGHT - GAP * (SIZING_ROWS - 1)) / SIZING_ROWS);

  return {
    columns: COLUMNS,
    rows: Math.ceil(n / COLUMNS), // rows actually occupied
    gap: GAP,
    cardWidth,
    rowHeight,
    containerWidth: USABLE_WIDTH
  };
};

// Helper function to get the appropriate supplement images based on report mode
const getSupplementImages = (reportMode, useThaiVersion, supplement9PVersion = 'new') => {
  // New formula: shared single-strain SKU image configs for every supported panel.
  if (supplement9PVersion === 'new' && panelSupportsNewFormula(reportMode)) {
    return useThaiVersion ? supplement_images9P_thai : supplement_images9P_eng;
  }
  if (reportMode === 'Allergy and Skin') {
    // AMG supplement images for Allergy and Skin
    const { supplement_images_eng: supplement_images_AMG_eng, supplement_images_thai: supplement_images_AMG_thai } = require('../../configs/supplement/AMG_supplement');
    return useThaiVersion ? supplement_images_AMG_thai : supplement_images_AMG_eng;
  } else if (reportMode === 'Toxin') {
    // Import Toxin supplement images directly
    const { supplement_images_eng, supplement_images_thai } = require('../../configs/supplement/toxin_supplement');
    return useThaiVersion ? supplement_images_thai : supplement_images_eng;
  } else if (reportMode === 'oms') {
    // Import OMS supplement images directly
    const { supplement_images_oms_eng, supplement_images_oms_thai } = require('../../configs/supplement/oms_supplement');
    return useThaiVersion ? supplement_images_oms_thai : supplement_images_oms_eng;
  } else if (reportMode === '9P') {
    if (supplement9PVersion === 'old') {
      return useThaiVersion ? supplement_images9P_thai_old : supplement_images9P_eng_old;
    }
    return useThaiVersion ? supplement_images9P_thai : supplement_images9P_eng;
  } else if (reportMode === 'bwcdiamond') {
    return useThaiVersion ? supplement_images_bwcdiamond_thai : supplement_images_bwcdiamond_eng;
  } else {
    // Default to QPT for all other formats
    return useThaiVersion ? supplement_images_thai : supplement_images_eng;
  }
};

// Helper function to get supplement image name based on toggle state
const getSupplementImageName = (supplementName, reportMode, csvPreviewToggle, useThaiVersion) => {
  console.log(`=== getSupplementImageName DEBUG for ${supplementName} ===`);
  console.log('Report Mode:', reportMode);
  console.log('CSV Preview Toggle:', csvPreviewToggle);
  console.log('Use Thai Version:', useThaiVersion);
  
  if (reportMode === '9P') {
    // New-formula single-strain SKUs carry their own image_name (which includes
    // the `newformula/` sub-folder), so prefer the config over the legacy maps.
    const skuConfig = useThaiVersion ? supplement_images9P_thai : supplement_images9P_eng;
    if (skuConfig && skuConfig[supplementName] && skuConfig[supplementName].image_name) {
      const result = skuConfig[supplementName].image_name;
      console.log('9P config image name:', result);
      return result;
    }
  }

  if (reportMode === '9P' && csvPreviewToggle) {
    // B2B mode - use 9P-specific image names
    const imageMappings = {
      'BioAll': useThaiVersion ? 'bioall9P_thai' : 'bioall9P',
      'BioZen': useThaiVersion ? 'biozen9P_thai' : 'biozen9P', 
      'BioMeta': useThaiVersion ? 'biometa9P_thai' : 'biometa9P',
      'BioGrace': useThaiVersion ? 'biograce_thai' : 'biograce'
    };
    const result = imageMappings[supplementName] || supplementName;
    console.log('B2B mode - Generated image name:', result);
    return result;
  } else if (reportMode === '9P' && !csvPreviewToggle) {
    // B2C mode - use regular image names with _thai suffix for Thai version
    const imageMappings = {
      'BioAll': useThaiVersion ? 'bioall_thai' : 'bioall',
      'BioZen': useThaiVersion ? 'biozen_thai' : 'biozen', 
      'BioMeta': useThaiVersion ? 'biometa_thai' : 'biometa',
      'BioGrace': useThaiVersion ? 'biograce_thai' : 'biograce'
    };
    const result = imageMappings[supplementName] || supplementName;
    console.log('B2C mode - Generated image name:', result);
    return result;
  }
  // QPT panel and Allergy and Skin_kids (same as QPT) - use image_name from QPT config
  if (reportMode === 'QPT' || reportMode === 'Allergy and Skin_kids') {
    const { supplement_images_eng: engConfig, supplement_images_thai: thaiConfig } = require('../../configs/supplement/qpt_supplement');
    const supplementConfig = useThaiVersion ? thaiConfig : engConfig;
    if (supplementConfig && supplementConfig[supplementName]) {
      return supplementConfig[supplementName].image_name;
    }
  }
  // Other panels - use image_name from config if available, otherwise supplement name
  if (reportMode === 'Allergy and Skin' || reportMode === 'Toxin' || reportMode === 'oms') {
    let supplementConfig;
    if (reportMode === 'Allergy and Skin') {
      const { supplement_images_eng: engConfig, supplement_images_thai: thaiConfig } = require('../../configs/supplement/AMG_supplement');
      supplementConfig = useThaiVersion ? thaiConfig : engConfig;
    } else if (reportMode === 'Toxin') {
      const { supplement_images_eng: engConfig, supplement_images_thai: thaiConfig } = require('../../configs/supplement/toxin_supplement');
      supplementConfig = useThaiVersion ? thaiConfig : engConfig;
    } else if (reportMode === 'oms') {
      const { supplement_images_oms_eng: engConfig, supplement_images_oms_thai: thaiConfig } = require('../../configs/supplement/oms_supplement');
      supplementConfig = useThaiVersion ? thaiConfig : engConfig;
    }
    
    // Get the image_name from the config
    if (supplementConfig && supplementConfig[supplementName]) {
      return supplementConfig[supplementName].image_name;
    }
  }
  
  return supplementName;
};

function formatDateThai(dateInput) {
  const d = dateInput instanceof Date ? dateInput : parseFlexibleDDMMYYYY(dateInput);
  if (!d || isNaN(d)) return 'N/A';

  const monthsThai = [
    'มกราคม', 'กุมภาพันธ์', 'มีนาคม', 'เมษายน', 'พฤษภาคม', 'มิถุนายน',
    'กรกฎาคม', 'สิงหาคม', 'กันยายน', 'ตุลาคม', 'พฤศจิกายน', 'ธันวาคม'
  ];

  return `${d.getDate()} ${monthsThai[d.getMonth()]} ${d.getFullYear() + 543}`;
}


function parseFlexibleDDMMYYYY(dateStr) {
  if (!dateStr || typeof dateStr !== 'string') return null;

  const str = dateStr.trim();
  if (/^(n\/a|na|null)$/i.test(str)) return null;

  const parts = str.split('/');
  if (parts.length !== 3) return null;

  const [dayStr, monthStr, yearStr] = parts;
  const day = parseInt(dayStr, 10);
  const month = parseInt(monthStr, 10);
  const year = parseInt(yearStr, 10);

  if (!day || !month || !year) return null;

  const date = new Date(year, month - 1, day);
  if (
    date.getFullYear() !== year ||
    date.getMonth() + 1 !== month ||
    date.getDate() !== day
  ) {
    return null;
  }

  return date;
}


/**
 * Tolerant date parser for values that reach us from more than one source.
 * The CSV preview hands us "DD/MM/YYYY" strings, but `Report Date` is a DATE
 * column so a report re-opened from history (or rendered server-side from
 * `SELECT * FROM st_report`) arrives as a Date instance or an ISO string.
 * `cleanReportData` in DashboardPage also turns a blank cell into the number 0
 * on the way to the DB, so 0 counts as "no value".
 * Returns null when there is nothing usable.
 */
function parseFlexibleDate(value) {
  if (value === null || value === undefined) return null;

  if (value instanceof Date) {
    return isNaN(value.getTime()) ? null : value;
  }

  const str = String(value).trim();
  if (str === '' || str === '0' || /^(n\/a|na|null|undefined)$/i.test(str)) return null;

  // ISO: YYYY-MM-DD, optionally with a time part. Build a local date from the
  // date half only — `new Date('2026-03-15')` is parsed as UTC midnight, which
  // renders as the 14th for an Asia/Bangkok viewer.
  const iso = str.match(/^(\d{4})-(\d{2})-(\d{2})/);
  if (iso) {
    const [, y, m, d] = iso;
    const date = new Date(Number(y), Number(m) - 1, Number(d));
    return isNaN(date.getTime()) ? null : date;
  }

  // Day-first: DD/MM/YYYY or DD-MM-YYYY.
  return parseFlexibleDDMMYYYY(str.replace(/-/g, '/'));
}


/**
 * Renders a stored Report Date. Prints '-' when the row has no usable value
 * (blank CSV cell, or a report saved before the column existed) rather than
 * silently substituting today's date.
 */
function formatReportDate(raw, useThaiVersion) {
  const d = parseFlexibleDate(raw);
  if (!d) return '-';

  return useThaiVersion
    ? formatDateThai(d)
    : d.toLocaleDateString('en-GB', {
        day: '2-digit',
        month: 'long',
        year: 'numeric',
      });
}


// eslint-disable-next-line no-unused-vars
function parseDDMMYYYY(dateStr) {
  const [day, month, year] = dateStr.split('/');
  return new Date(`${year}-${month}-${day}`); // ISO format = yyyy-mm-dd
}

function translateGender(gender) {
  if (!gender) return '';
  const lower = gender.toLowerCase();
  if (lower === 'male') return 'ชาย';
  if (lower === 'female') return 'หญิง';
  return gender; // fallback
}

// eslint-disable-next-line no-unused-vars
function getScoreGroup(score) {
  if (score >= 1 && score <= 3) return 0;
  if (score >= 4 && score <= 6) return 1;
  if (score >= 7 && score <= 10) return 2;
  return 'x';
}

const rotationRanges = [
    {
      min: 0,
      max: 3.99,
      rotation: '-75deg',
      top: '210px',
      left: '56%',
      transformOrigin: 'center bottom',
      label: 'Generally Balanced',
      color: 'green'
    },
    {
      min: 4,
      max: 6.99,
      rotation: '-22deg',
      top: '230px',
      left: '52%',
      transformOrigin: 'center bottom',
      label: 'Mild Dysbiosis',
      color: 'goldenrod'
    },
    {
      min: 7,
      max: 9.99,
      rotation: '28deg',
      top: '240px',
      left: '47%',
      transformOrigin: 'center bottom',
      label: 'Moderate Dysbiosis',
      color: 'orange'
    },
    {
      min: 10,
      max: 100,
      rotation: '81deg',
      top: '200px',
      left: '44%',
      transformOrigin: 'center bottom',
      label: 'Severe Dysbiosis',
      color: 'red'
    }
  ];

const PdfStaticModal = ({
  formData,
  fromCsvPreview,
  useThaiVersion,
  pdfBasePath,
  totalPages,
  reportMode,
  onClose,
  onBackToCsv,
  onToggleLanguage,
  selectedSupplements = [],
  stock,
  csvPreviewToggle = true,
  duration = null,
  supplement9PVersion = 'new'
}) => {
  // Keep the calculation module in sync with the chosen version so this modal's
  // internal getRecommendedSupplements picks the right formula.
  set9PSupplementVersion(supplement9PVersion);
  // "New formula" (shared single-strain SKU cards) is active when the panel
  // supports the toggle AND the user chose it. Otherwise the panel renders its
  // own original supplement images/instructions.
  const isNewFormula = panelSupportsNewFormula(reportMode) && supplement9PVersion === 'new';
  // Debug: Check duration value
  console.log('๐” PdfStaticModal - Duration prop:', duration);
  console.log('๐” PdfStaticModal - FormData duration:', formData?.['Probiotics (months)']);
  console.log('๐” PdfStaticModal - From CSV preview:', fromCsvPreview);
  console.log('๐” PdfStaticModal - useThaiVersion:', useThaiVersion);
  console.log('๐” PdfStaticModal - Font stack:', FONT_STACK_MIXED_THAI_LATIN);
  console.log('๐” PdfStaticModal - reportMode prop:', reportMode);
  
  // Debug: Log all bacteria values for QI panel
  if (reportMode === 'Allergy and Skin_kids') {
    console.log('๐” QI Panel Bacteria Values:');
    console.log('  Bifidobacterium bifidum:', formData?.['Bifidobacterium bifidum']);
    console.log('  Lactobacillus paracasei:', formData?.['Lactobacillus paracasei']);
    console.log('  Lactobacillus plantarum:', formData?.['Lactobacillus plantarum']);
    console.log('  Ruminococcus bromii:', formData?.['Ruminococcus bromii']);
    console.log('  Staphylococcus aureus:', formData?.['Staphylococcus aureus']);
    console.log('  Lactobacillus acidophilus:', formData?.['Lactobacillus acidophilus']);
    console.log('  Lactobacillus rhamnosus:', formData?.['Lactobacillus rhamnosus']);
    console.log('  Bacteroidetes phylum:', formData?.['Bacteroidetes phylum']);
    console.log('  Bifidobacterium longum:', formData?.['Bifidobacterium longum']);
    console.log('  Universal bacteria:', formData?.['Universal bacteria']);
  }

const renderPageNumber = (pageNumber) => {
  let engPages = null;
  let thaiPages = null;

  if (reportMode === 'QPT') {
    engPages = qpt_numberpage_eng; thaiPages = qpt_numberpage_thai;
  } else if (reportMode === '9P') {
    engPages = NineP_numberpage_eng; thaiPages = NineP_numberpage_thai;
  } else if (reportMode === 'Allergy and Skin' || reportMode === 'Allergy and Skin_kids') {
    engPages = as_numberpage_eng; thaiPages = as_numberpage_thai;
  } else if (reportMode === 'Toxin') {
    engPages = toxin_numberpage_eng; thaiPages = toxin_numberpage_thai;
  } else if (reportMode === 'oms') {
    engPages = oms_numberpage_eng; thaiPages = oms_numberpage_thai;
  } else if (reportMode === 'bwcallergy') {
    engPages = bwcallergy_numberpage_eng; thaiPages = bwcallergy_numberpage_thai;
  } else if (reportMode === 'bwccore') {
    engPages = bwccore_numberpage_eng; thaiPages = bwccore_numberpage_thai;
  } else if (reportMode === 'bwcdiamond') {
    engPages = bwcdiamond_numberpage_eng; thaiPages = bwcdiamond_numberpage_thai;
  } else {
    return null;
  }

  const pages = useThaiVersion ? thaiPages : engPages;
  if (!pages || !engPages) return null;

  // The printed number is COMPUTED from the page's position in the booklet, not
  // read from the config, so dynamically inserted pages (e.g. the 9P supplement
  // overflow page) renumber everything after them automatically.
  //
  // Every config in pdfnumberpageConfig.js is a strict run (text = start + index),
  // so `start` is recovered from its first numbered entry and the computed value
  // matches the static list exactly when nothing has been inserted. The config is
  // still the source of truth for POSITION and for pages it deliberately blanks.
  const firstNumberedIndex = pages.findIndex((p) => p && typeof p.text === 'number');
  if (firstNumberedIndex === -1) return null;

  // The Thai section continues the English section's numbering, so its first
  // number is derived from the English page count instead of being hard-coded.
  // Every panel's config already matched engLength + 1 except 9P, whose Thai
  // list still said 19 while the English section had grown to 22 pages.
  // Pages inserted dynamically (the supplement overflow) shift it as well,
  // since the English section gains the same extra page(s).
  const startNumber = useThaiVersion
    ? engPages.length + extraSupplementPages + 1
    : pages[firstNumberedIndex].text - firstNumberedIndex;

  const entry = pages[pageNumber - 1];
  // Pages the config blanks or skips (e.g. the 9P/QPT cover) stay unnumbered.
  if (entry && (entry.skip || entry.text === undefined || entry.text === '')) return null;

  // Inserted pages run past the end of the config: reuse the last known position.
  const pageConfig = entry || pages[pages.length - 1];
  if (!pageConfig) return null;

  const pageText = startNumber + (pageNumber - 1);

  return (
    <div
      className="pdf-overlay-text"
      style={{
        position: 'absolute',
        top: `${pageConfig.ypos}px`,
        left: `${pageConfig.xpos}px`,
        fontSize: '12px',
        color: '#333',
        fontWeight: 'normal',
        zIndex: 5
      }}
    >
      {pageText}
    </div>
  );
};

const resolvedTotalPages =
    reportMode === '9P'
    ? (useThaiVersion ? 31 : 22)
    : reportMode === 'Allergy and Skin'
    ? (useThaiVersion ? 26 : 18)
    : reportMode === 'Allergy and Skin_kids'
    ? (useThaiVersion ? 26 : 18)
    : reportMode === 'Toxin'
    ? (useThaiVersion ? 26 : 18)
    : reportMode === 'oms'
    ? (useThaiVersion ? 27 : 19)
    : reportMode === 'bwcallergy'
    ? (useThaiVersion ? 25 : 20)
    : reportMode === 'bwccore'
    ? (useThaiVersion ? 26 : 21)
    : reportMode === 'bwcdiamond'
    ? (useThaiVersion ? 33 : 26)
    : (useThaiVersion ? 53 : 43);

const resolvedPdfBasePath =
  reportMode === '9P'
    ? (useThaiVersion ? '/9P/thai' : '/9P/eng')
    : reportMode === 'Allergy and Skin'
    ? (useThaiVersion ? '/pdf_allergy/thai' : '/pdf_allergy/eng')
    : reportMode === 'Allergy and Skin_kids'
    ? (useThaiVersion ? '/pdf_allergy_kids/thai' : '/pdf_allergy_kids/eng')
    : reportMode === 'Toxin'
    ? (useThaiVersion ? '/pdf_toxin/thai' : '/pdf_toxin/eng')
    : reportMode === 'oms'
    ? (useThaiVersion ? '/pdf_oms/thai' : '/pdf_oms/eng')
    : reportMode === 'bwcallergy'
    ? (useThaiVersion ? '/BWC/bwc_allergyss/thai' : '/BWC/bwc_allergyss/eng')
    : reportMode === 'bwccore'
    ? (useThaiVersion ? '/BWC/bwc_core/thai' : '/BWC/bwc_core/eng')
    : reportMode === 'bwcdiamond'
    ? (useThaiVersion ? '/BWC/bwc_diamond/thai' : '/BWC/bwc_diamond/eng')
    : useThaiVersion
    ? '/pdf_QPTthai'
    : '/pdfpages';

const activeOverlayConfig =
  reportMode === '9P'
    ? (useThaiVersion ? pdfOverlayConfigPersonal_9P.thai : pdfOverlayConfigPersonal_9P.eng)
    : reportMode === 'Allergy and Skin'
    ? (useThaiVersion ? pdfOverlayConfigPersonal_allergy.thai : pdfOverlayConfigPersonal_allergy.eng)
    : reportMode === 'Allergy and Skin_kids'
    ? (useThaiVersion ? pdfOverlayConfigPersonal_allergy_kids.thai : pdfOverlayConfigPersonal_allergy_kids.eng)
    : reportMode === 'Toxin'
    ? (useThaiVersion ? pdfOverlayConfigPersonal_toxin.thai : pdfOverlayConfigPersonal_toxin.eng)
    : reportMode === 'oms'
    ? (useThaiVersion ? pdfOverlayConfigPersonal_oms.thai : pdfOverlayConfigPersonal_oms.eng)
    : reportMode === 'bwcallergy'
    ? (useThaiVersion ? pdfOverlayConfigPersonal_bwcallergy.thai : pdfOverlayConfigPersonal_bwcallergy.eng)
    : reportMode === 'bwccore'
    ? (useThaiVersion ? pdfOverlayConfigPersonal_bwccore.thai : pdfOverlayConfigPersonal_bwccore.eng)
    : reportMode === 'bwcdiamond'
    ? (useThaiVersion ? pdfOverlayConfigPersonal_bwcdiamond.thai : pdfOverlayConfigPersonal_bwcdiamond.eng)
    : useThaiVersion
    ? pdfOverlayConfigPersonal.thai
    : pdfOverlayConfigPersonal.eng;

const activeDiseases =
  reportMode === '9P'
    ? (useThaiVersion ? diseases_9P_thai : diseases_9P_eng)
    : reportMode === 'Allergy and Skin'
    ? (useThaiVersion ? diseases_allergy_thai : diseases_allergy_eng)
    : reportMode === 'Allergy and Skin_kids'
    ? (useThaiVersion ? diseases_allergy_kids_thai : diseases_allergy_kids_eng)
    : reportMode === 'Toxin'
    ? (useThaiVersion ? diseases_toxin_thai : diseases_toxin_eng)
    : reportMode === 'oms'
    ? (useThaiVersion ? diseases_oms_thai : diseases_oms_eng)
    : reportMode === 'bwcallergy'
    ? (useThaiVersion ? diseases_bwcallergy_thai : diseases_bwcallergy_eng)
    : reportMode === 'bwccore'
    ? (useThaiVersion ? diseases_bwccore_thai : diseases_bwccore_eng)
    : reportMode === 'bwcdiamond'
    ? (useThaiVersion ? diseases_bwcdiamond_thai : diseases_bwcdiamond_eng)
    : useThaiVersion
    ? diseases_thai
    : diseases;

const activeDiseasesImage =
  reportMode === '9P'
    ? (useThaiVersion ? diseases_image_9P_thai : diseases_image_9P_eng)
    : reportMode === 'Allergy and Skin'
    ? (useThaiVersion ? diseases_image_allergy_thai : diseases_image_allergy_eng)
    : reportMode === 'Allergy and Skin_kids'
    ? (useThaiVersion ? diseases_image_allergy_kids_thai : diseases_image_allergy_kids_eng)
    : reportMode === 'Toxin'
    ? (useThaiVersion ? diseases_image_toxin_thai : diseases_image_toxin_eng)
    : reportMode === 'oms'
    ? (useThaiVersion ? diseases_image_oms_thai : diseases_image_oms_eng)
    : reportMode === 'bwcallergy'
    ? (useThaiVersion ? diseases_image_bwcallergy_thai : diseases_image_bwcallergy_eng)
    : reportMode === 'bwccore'
    ? (useThaiVersion ? diseases_image_bwccore_thai : diseases_image_bwccore_eng)
    : reportMode === 'bwcdiamond'
    ? (useThaiVersion ? diseases_image_bwcdiamond_thai : diseases_image_bwcdiamond_eng)
    : useThaiVersion
    ? diseases_image_thai
    : diseases_image;

  // Lazy initializers run synchronously on first render (works in SSR + browser).
  const [results, setResults] = useState(() => computeMainScoresSync(formData, reportMode).results);
  const [scores, setScores] = useState(() => computeMainScoresSync(formData, reportMode).scores);
  const [average, setAverage] = useState(0);
  /* eslint-disable no-unused-vars */
  const [_formResults, _setFormResults] = useState({});
  const [_formScores, _setFormScores] = useState({});
  const [_formAverage, _setFormAverage] = useState(0);
  const [_positionsReady, setPositionsReady] = useState(false);
  /* eslint-enable no-unused-vars */
  const [vitaminBScores, setVitaminBScores] = useState(() => computeVitaminBScoresSync(formData, reportMode).scores);
  const [vitaminBResults, setVitaminBResults] = useState(() => computeVitaminBScoresSync(formData, reportMode).results);
  const [neurotransmitterScores, setNeurotransmitterScores] = useState(() => computeNeurotransmitterScoresSync(formData, reportMode).scores);
  const [neurotransmitterResults, setNeurotransmitterResults] = useState(() => computeNeurotransmitterScoresSync(formData, reportMode).results);
  const [metabolitesScores, setMetabolitesScores] = useState(() => computeMetabolitesScoresSync(formData, reportMode).scores);
  const [metabolitesResults, setMetabolitesResults] = useState(() => computeMetabolitesScoresSync(formData, reportMode).results);
  const [macronutrientScores, setMacronutrientScores] = useState(() => computeMacronutrientScoresSync(formData, reportMode).scores);
  const [macronutrientResults, setMacronutrientResults] = useState(() => computeMacronutrientScoresSync(formData, reportMode).results);

  // Calculate recommended supplements
  const calculateSupplements = (formData, reportMode, excludedSupplements = []) => {
    const result = getRecommendedSupplements(formData, reportMode, stock, excludedSupplements, 800, {});
    return result.supplements || [];
  };

  // Update where supplements are calculated
  const excludedSupplements = []; // Assuming an empty excludedSupplements array
  const recommendedSupplements = calculateSupplements(formData, reportMode, excludedSupplements);

  // The panel's supplement-page layout config (where cards/images render and on
  // which page). New formula reuses each panel's own supplement page position.
  const activeSupplementChoosing = (() => {
    if (reportMode === '9P') return isNewFormula ? choosing_supplement_9P[0] : choosing_supplement_9P_old[0];
    if (reportMode === 'oms') return choosing_supplement_oms[0];
    if (reportMode === 'Allergy and Skin') return choosing_supplement_AMG[0];
    if (reportMode === 'Allergy and Skin_kids') return qpt_choosing_supplement[0];
    if (reportMode === 'Toxin') return choosing_supplement_toxin[0];
    if (['bwcallergy', 'bwccore'].includes(reportMode)) return choosing_supplement_bwc[0];
    if (reportMode === 'bwcdiamond') return choosing_supplement_bwcdiamond[0];
    return qpt_choosing_supplement[0];
  })();

  // Quick Navigation jump targets, resolved to the active language's page.
  // 9P uses its explicit config; every other toggle-capable panel gets a jump to
  // its own supplement recommendation page (derived from activeSupplementChoosing),
  // so the preview has the same navigator as Q9.
  const quickNavItems = (() => {
    const staticCfg = QUICK_NAV_PAGES[reportMode];
    if (staticCfg) {
      return staticCfg.map((e) => ({ text: e.text, page: useThaiVersion ? e.page_thai : e.page_eng }));
    }
    if (panelSupportsNewFormula(reportMode)) {
      return [{
        text: 'Your Probiotics Recommendation',
        page: useThaiVersion ? activeSupplementChoosing.page_thai : activeSupplementChoosing.page_eng
      }];
    }
    return [];
  })();

  // ---- New-formula supplement overflow ----------------------------------
  // Only MAX_9P_SUPPLEMENTS cards fit on one page. When more are recommended
  // the extras spill onto duplicates of the same supplement page template, and
  // every page after it shifts down by that many. New formula only.
  //
  // This is the ONE canonical list: the chunk maths below and every rendered
  // card derive from it, so a page can never show cards the pagination didn't
  // account for. The selectedSupplements prop can be stale from the OTHER
  // version (e.g. old product names while New is active), which would leave
  // entries without a card config and render nothing โ€” so names the active
  // version doesn't know are dropped, falling back to the freshly computed
  // recommendations (which always match the active version).
  const newFormulaValidNames = isNewFormula
    ? new Set(Object.keys(getSupplementImages(reportMode, useThaiVersion, 'new')))
    : null;
  const supplement9PList = (() => {
    if (!isNewFormula) return [];
    const base = selectedSupplements.length > 0 ? selectedSupplements : recommendedSupplements;
    const filtered = (base || []).filter((s) => newFormulaValidNames.has(s));
    return filtered.length > 0
      ? filtered
      : (recommendedSupplements || []).filter((s) => newFormulaValidNames.has(s));
  })();
  const supplement9PPage = useThaiVersion
    ? activeSupplementChoosing.page_thai
    : activeSupplementChoosing.page_eng;
  // Panels whose config deliberately has no supplement page (the BWC booklets
  // don't have one) must never insert overflow pages โ€” without this guard the
  // page comparisons below go NaN and shift every page image by one.
  const hasSupplementPage = Number.isFinite(supplement9PPage);
  const extraSupplementPages = (isNewFormula && hasSupplementPage)
    ? Math.max(0, Math.ceil(supplement9PList.length / MAX_9P_SUPPLEMENTS) - 1)
    : 0;
  const totalPagesWithOverflow = resolvedTotalPages + extraSupplementPages;

  // Rendered page -> source page in the PNG booklet, plus which slice of the
  // supplement list that page shows (chunk 0 is the original page).
  const mapRenderedPage = (rendered) => {
    if (extraSupplementPages === 0 || rendered < supplement9PPage) {
      return { source: rendered, chunk: 0 };
    }
    if (rendered <= supplement9PPage + extraSupplementPages) {
      return { source: supplement9PPage, chunk: rendered - supplement9PPage };
    }
    return { source: rendered - extraSupplementPages, chunk: 0 };
  };

  // The supplement cards for a given chunk (page) of the recommendation list.
  const supplementsForChunk = (chunk) =>
    supplement9PList.slice(chunk * MAX_9P_SUPPLEMENTS, (chunk + 1) * MAX_9P_SUPPLEMENTS);

  // Positioned grid of Supplement Facts cards โ€” shared by the first supplement
  // page and any overflow pages, so the two can never drift apart.
  const render9PSupplementGrid = (list, config, keySuffix) => {
    if (!list.length) return null;
    const grid = get9PSupplementGridLayout(list.length);
    return (
      <div
        key={`supplement-grid-${keySuffix}`}
        style={{
          position: 'absolute',
          top: `${config.Ypos_text}px`,
          left: `${config.Xpos_text}px`,
          // Fixed 3-track grid: cards align to columns and keep one size
          // whether this page holds 1 card or 9.
          display: 'grid',
          gridTemplateColumns: `repeat(${grid.columns}, ${grid.cardWidth}px)`,
          // Fixed row height so three rows always fit the page regardless of
          // how much text a card's ingredients list happens to hold.
          gridAutoRows: `${grid.rowHeight}px`,
          justifyContent: 'center',
          width: `${grid.containerWidth}px`,
          gap: `${grid.gap}px`,
          zIndex: 5
        }}
      >
        {list.map((supp) => (
          <div
            key={supp}
            style={{ position: 'relative', flex: '0 0 auto', width: `${grid.cardWidth}px`, minWidth: 0 }}
          >
            <Supplement9PCard
              sku={supp}
              width={grid.cardWidth}
              height={grid.rowHeight}
              useThaiVersion={useThaiVersion}
            />
          </div>
        ))}
      </div>
    );
  };

  // Calculate overall gut health score
  const getActiveBacteriaMetaConfig = () => {
    return reportMode === '9P'
      ? bacteriaMetaConfig_9P
      : reportMode === 'Allergy and Skin'
      ? bacteriaMetaConfig_allergy
      : reportMode === 'Allergy and Skin_kids'
      ? bacteriaMetaConfig_allergy_kids
      : reportMode === 'Toxin'
      ? bacteriaMetaConfig_toxin
      : reportMode === 'oms'
      ? bacteriaMetaConfig_oms
      : reportMode === 'bwcallergy'
      ? bacteriaMetaConfig_bwcallergy
      : reportMode === 'bwccore'
      ? bacteriaMetaConfig_bwccore
      : reportMode === 'bwcdiamond'
      ? bacteriaMetaConfig_bwcdiamond
      : bacteriaMetaConfig;
  };

  // Get the appropriate scoring functions based on report mode
  const scoringFunctions = getScoringFunctions(reportMode);
  const overallScore = scoringFunctions.calculateOverallScore(formData, getActiveBacteriaMetaConfig());
  const scoringLevel = scoringFunctions.getScoringLevel(overallScore, useThaiVersion);

  // 9P macronutrient summary section (sum of species scores -> result label)
  const macro9P = reportMode === '9P'
    ? calculateMacronutrient9P(formData, useThaiVersion)
    : null;
  if (macro9P) {
    console.log('๐” 9P macronutrient - sum:', macro9P.sum, 'label:', macro9P.label);
  }

  // 9P vitamin B biosynthesis summary section (sum of species scores -> result label)
  const vitaminB9P = reportMode === '9P'
    ? calculateVitaminB9P(formData, useThaiVersion)
    : null;
  if (vitaminB9P) {
    console.log('๐” 9P vitamin B - sum:', vitaminB9P.sum, 'label:', vitaminB9P.label);
  }

  // 9P SCFAs summary section (sum of species scores -> result label)
  const scfas9P = reportMode === '9P'
    ? calculateScfas9P(formData, useThaiVersion)
    : null;
  if (scfas9P) {
    console.log('๐” 9P SCFAs - sum:', scfas9P.sum, 'label:', scfas9P.label);
  }

  // 9P Neurotransmitter summary section (sum of species scores -> result label)
  const neuro9P = reportMode === '9P'
    ? calculateNeurotransmitter9P(formData, useThaiVersion)
    : null;
  if (neuro9P) {
    console.log('๐” 9P Neurotransmitter - sum:', neuro9P.sum, 'label:', neuro9P.label);
  }

const layoutSource =
  reportMode === '9P'
    ? (useThaiVersion ? bacteriaLayoutConfig_9P_thai : bacteriaLayoutConfig_9P_eng)
    : reportMode === 'Allergy and Skin'
    ? (useThaiVersion ? bacteriaLayoutConfig_allergy_thai : bacteriaLayoutConfig_allergy_eng)
    : reportMode === 'Allergy and Skin_kids'
    ? (useThaiVersion ? bacteriaLayoutConfig_allergy_kids_thai : bacteriaLayoutConfig_allergy_kids_eng)
    : reportMode === 'Toxin'
    ? (useThaiVersion ? bacteriaLayoutConfig_toxin_thai : bacteriaLayoutConfig_toxin_eng)
    : reportMode === 'oms'
    ? (useThaiVersion ? bacteriaLayoutConfig_oms_thai : bacteriaLayoutConfig_oms_eng)
    : reportMode === 'bwcallergy'
    ? (useThaiVersion ? bacteriaLayoutConfig_bwcallergy_thai : bacteriaLayoutConfig_bwcallergy_eng)
    : reportMode === 'bwccore'
    ? (useThaiVersion ? bacteriaLayoutConfig_bwccore_thai : bacteriaLayoutConfig_bwccore_eng)
    : reportMode === 'bwcdiamond'
    ? (useThaiVersion ? bacteriaLayoutConfig_bwcdiamond_thai : bacteriaLayoutConfig_bwcdiamond_eng)
    : useThaiVersion
    ? scoreLabelPositionThai
    : bacteriaLayoutConfig;

const combinedBarConfig = layoutSource.map(layout => {
  const meta =
    reportMode === '9P'
      ? bacteriaMetaConfig_9P[layout.label]
      : reportMode === 'Allergy and Skin'
      ? bacteriaMetaConfig_allergy[layout.label]
      : reportMode === 'Allergy and Skin_kids'
      ? bacteriaMetaConfig_allergy_kids[layout.label]
      : reportMode === 'Toxin'
      ? bacteriaMetaConfig_toxin[layout.label]
      : reportMode === 'oms'
      ? bacteriaMetaConfig_oms[layout.label]
      : reportMode === 'bwcallergy'
      ? bacteriaMetaConfig_bwcallergy[layout.label]
      : reportMode === 'bwccore'
      ? bacteriaMetaConfig_bwccore[layout.label]
      : reportMode === 'bwcdiamond'
      ? bacteriaMetaConfig_bwcdiamond[layout.label]
      : bacteriaMetaConfig[layout.label];

  return { ...meta, ...layout };
});

// Function to calculate vitamin B scores
const calculateVitaminBScores = (formData, reportMode) => {
  // Only calculate for QPT format
  if (reportMode !== 'QPT') {
    return { scores: {}, results: {} };
  }

  const vitaminBScores = {};
  const vitaminBResults = {};

  // Get the correct meta config based on reportMode
  const metaSource = bacteriaMetaConfig;

  // Helper function to get score_cal for a species
  const getScoreCal = (speciesName, rawValue) => {
    const meta = metaSource[speciesName];
    if (!meta || !Array.isArray(meta.rangeMapping)) {
      return 0;
    }

    const raw = parseFloat(rawValue) || 0;
    let matched;
    if (meta.customCondition) {
      matched = meta.rangeMapping.find(r => 
        typeof r.condition === 'function' && evaluateBacteriaCondition(r.condition, raw, formData, speciesName)
      );
    } else {
      matched = meta.rangeMapping.find(r => raw >= r.min && raw <= r.max);
    }
    
    if (matched && matched.score_cal !== undefined) {
      return matched.score_cal;
    }
    return 0;
  };

  // Helper function to get multiplier based on score_cal
  const getMultiplier = (scoreCal) => {
    if (scoreCal === 3) return vitaminB_multi.case1.multiply;
    if (scoreCal === 2) return vitaminB_multi.case2.multiply;
    if (scoreCal === 1) return vitaminB_multi.case3.multiply;
    return vitaminB_multi.othercase.multiply;
  };

  // Calculate for each vitamin B
  Object.keys(vitaminB_sp).forEach((vitamin) => {
    const speciesMap = vitaminB_sp[vitamin];
    let sum = 0;

    // Iterate through each species for this vitamin
    Object.keys(speciesMap).forEach((speciesName) => {
      const speciesValue = speciesMap[speciesName];
      const rawValue = formData[speciesName];
      
      if (rawValue !== undefined && rawValue !== '') {
        const raw = parseFloat(rawValue) || 0;
        
        // Check if ct value >= 35, if so use 0 multiplier
        if (raw >= 35) {
          // Use 0 multiplier, so contribution is 0
          sum += 0;
        } else {
          // Get score_cal for this species
          const scoreCal = getScoreCal(speciesName, raw);
          // Get multiplier based on score_cal
          const multiplier = getMultiplier(scoreCal);
          // Calculate: multiplier * species_value
          const contribution = multiplier * speciesValue;
          sum += contribution;
        }
      }
    });

    // Store the calculated sum
    vitaminBResults[vitamin] = sum.toFixed(2);

    // Find matching condition to get score
    const config = vitaminB_spCondition[vitamin];
    if (config && Array.isArray(config.conditions)) {
      const matched = config.conditions.find(c => c.condition(sum));
      if (matched) {
        vitaminBScores[vitamin] = matched.score;
      }
    }
  });

  return { scores: vitaminBScores, results: vitaminBResults };
};

// Function to calculate neurotransmitter scores
const calculateNeurotransmitterScores = (formData, reportMode) => {
  // Only calculate for QPT format
  if (reportMode !== 'QPT') {
    return { scores: {}, results: {} };
  }

  const neurotransmitterScores = {};
  const neurotransmitterResults = {};

  // Get the correct meta config based on reportMode
  const metaSource = bacteriaMetaConfig;

  // Helper function to get score_cal for a species
  const getScoreCal = (speciesName, rawValue) => {
    const meta = metaSource[speciesName];
    if (!meta || !Array.isArray(meta.rangeMapping)) {
      return 0;
    }

    const raw = parseFloat(rawValue) || 0;
    let matched;
    if (meta.customCondition) {
      matched = meta.rangeMapping.find(r => 
        typeof r.condition === 'function' && evaluateBacteriaCondition(r.condition, raw, formData, speciesName)
      );
    } else {
      matched = meta.rangeMapping.find(r => raw >= r.min && raw <= r.max);
    }
    
    if (matched && matched.score_cal !== undefined) {
      return matched.score_cal;
    }
    return 0;
  };

  // Helper function to get multiplier based on score_cal
  const getMultiplier = (scoreCal) => {
    if (scoreCal === 5) return neurotransmitter_multi.case1.multiply; // case1 has score_cal: 5
    if (scoreCal === 4) return neurotransmitter_multi.case2.multiply; // case2 has score_cal: 4
    if (scoreCal === 3) return neurotransmitter_multi.case3.multiply; // case3 has score_cal: 3
    if (scoreCal === 2) return neurotransmitter_multi.case4.multiply; // case4 has score_cal: 2
    if (scoreCal === 1) return neurotransmitter_multi.case5.multiply; // case5 has score_cal: 1
    return neurotransmitter_multi.othercase.multiply;
  };

  // Calculate for each neurotransmitter
  Object.keys(neurotransmitter_sp).forEach((neurotransmitterKey) => {
    const speciesMap = neurotransmitter_sp[neurotransmitterKey];
    let sum = 0;

    // Extract neurotransmitter name (remove _sp suffix)
    const neurotransmitterName = neurotransmitterKey.replace('_sp', '');

    // Iterate through each species for this neurotransmitter
    Object.keys(speciesMap).forEach((speciesName) => {
      const speciesValue = speciesMap[speciesName];
      const rawValue = formData[speciesName];
      
      if (rawValue !== undefined && rawValue !== '') {
        const raw = parseFloat(rawValue) || 0;
        
        // Check if ct value >= 35, if so use 0 multiplier
        if (raw >= 35) {
          // Use 0 multiplier, so contribution is 0
          sum += 0;
        } else {
          // Get score_cal for this species
          const scoreCal = getScoreCal(speciesName, raw);
          // Get multiplier based on score_cal
          const multiplier = getMultiplier(scoreCal);
          // Calculate: multiplier * species_value (can be negative for some species)
          const contribution = multiplier * speciesValue;
          sum += contribution;
        }
      }
    });

    // Store the calculated sum
    neurotransmitterResults[neurotransmitterName] = sum.toFixed(2);

    // Find matching condition to get score
    const config = neurotransmitter_spCondition[neurotransmitterName];
    if (config && Array.isArray(config.conditions)) {
      const matched = config.conditions.find(c => c.condition(sum));
      if (matched) {
        neurotransmitterScores[neurotransmitterName] = matched.score;
      }
    }
  });

  return { scores: neurotransmitterScores, results: neurotransmitterResults };
};

// Function to calculate metabolites scores
const calculateMetabolitesScores = (formData, reportMode) => {
  // Only calculate for QPT format
  if (reportMode !== 'QPT') {
    return { scores: {}, results: {} };
  }

  const metabolitesScores = {};
  const metabolitesResults = {};

  // Get the correct meta config based on reportMode
  const metaSource = bacteriaMetaConfig;

  // Helper function to get score_cal for a species
  const getScoreCal = (speciesName, rawValue) => {
    const meta = metaSource[speciesName];
    if (!meta || !Array.isArray(meta.rangeMapping)) {
      return 0;
    }

    const raw = parseFloat(rawValue) || 0;
    let matched;
    if (meta.customCondition) {
      matched = meta.rangeMapping.find(r => 
        typeof r.condition === 'function' && evaluateBacteriaCondition(r.condition, raw, formData, speciesName)
      );
    } else {
      matched = meta.rangeMapping.find(r => raw >= r.min && raw <= r.max);
    }
    
    if (matched && matched.score_cal !== undefined) {
      return matched.score_cal;
    }
    return 0;
  };

  // Helper function to get multiplier based on score_cal
  const getMultiplier = (scoreCal) => {
    if (scoreCal === 3) return metabolites_multi.case1.multiply; // case1 has score_cal: 3
    if (scoreCal === 2) return metabolites_multi.case2.multiply; // case2 has score_cal: 2
    if (scoreCal === 1) return metabolites_multi.case3.multiply; // case3 has score_cal: 1
    return metabolites_multi.othercase.multiply;
  };

  // Calculate for each metabolite
  Object.keys(metabolites_sp).forEach((metaboliteKey) => {
    const speciesMap = metabolites_sp[metaboliteKey];
    let sum = 0;

    // Extract metabolite name (remove _sp suffix)
    const metaboliteName = metaboliteKey.replace('_sp', '');

    // Iterate through each species for this metabolite
    Object.keys(speciesMap).forEach((speciesName) => {
      const speciesValue = speciesMap[speciesName];
      const rawValue = formData[speciesName];
      
      if (rawValue !== undefined && rawValue !== '') {
        const raw = parseFloat(rawValue) || 0;
        
        // Check if ct value >= 35, if so use 0 multiplier
        if (raw >= 35) {
          // Use 0 multiplier, so contribution is 0
          sum += 0;
        } else {
          // Get score_cal for this species
          const scoreCal = getScoreCal(speciesName, raw);
          // Get multiplier based on score_cal
          const multiplier = getMultiplier(scoreCal);
          // Calculate: multiplier * species_value
          const contribution = multiplier * speciesValue;
          sum += contribution;
        }
      }
    });

    // Store the calculated sum
    metabolitesResults[metaboliteName] = sum.toFixed(2);

    // Find matching condition to get score
    const config = metabolites_spCondition[metaboliteName];
    if (config && Array.isArray(config.conditions)) {
      const matched = config.conditions.find(c => c.condition(sum));
      if (matched) {
        metabolitesScores[metaboliteName] = matched.score;
      }
    }
  });

  return { scores: metabolitesScores, results: metabolitesResults };
};

// Function to calculate macronutrient scores
const calculateMacronutrientScores = (formData, reportMode) => {
  // Only calculate for QPT format
  if (reportMode !== 'QPT') {
    return { scores: {}, results: {} };
  }

  const macronutrientScores = {};
  const macronutrientResults = {};

  // Get the correct meta config based on reportMode
  const metaSource = bacteriaMetaConfig;

  // Helper function to get score_cal for a species
  const getScoreCal = (speciesName, rawValue) => {
    const meta = metaSource[speciesName];
    if (!meta || !Array.isArray(meta.rangeMapping)) {
      return 0;
    }

    const raw = parseFloat(rawValue) || 0;
    let matched;
    if (meta.customCondition) {
      matched = meta.rangeMapping.find(r => 
        typeof r.condition === 'function' && evaluateBacteriaCondition(r.condition, raw, formData, speciesName)
      );
    } else {
      matched = meta.rangeMapping.find(r => raw >= r.min && raw <= r.max);
    }
    
    if (matched && matched.score_cal !== undefined) {
      return matched.score_cal;
    }
    return 0;
  };

  // Helper function to get multiplier based on score_cal and whether species is harmful
  const getMultiplier = (scoreCal, isHarmful) => {
    if (isHarmful) {
      // Use harmful multiplier
      if (scoreCal === 5) return macronutrientharmful_multi.case1.multiply;
      if (scoreCal === 4) return macronutrientharmful_multi.case2.multiply;
      if (scoreCal === 3) return macronutrientharmful_multi.case3.multiply;
      return macronutrientharmful_multi.othercase.multiply;
    } else {
      // Use normal multiplier
      if (scoreCal === 1) return macronutrient_multi.case1.multiply;
      if (scoreCal === 2) return macronutrient_multi.case2.multiply;
      if (scoreCal === 3) return macronutrient_multi.case3.multiply;
      return macronutrient_multi.othercase.multiply;
    }
  };

  // Calculate for each macronutrient
  Object.keys(macronutrient_sp).forEach((macronutrientKey) => {
    const speciesMap = macronutrient_sp[macronutrientKey];
    let sum = 0;

    // Extract macronutrient name (already without _sp suffix)
    const macronutrientName = macronutrientKey;

    // Iterate through each species for this macronutrient
    Object.keys(speciesMap).forEach((speciesName) => {
      const speciesValue = speciesMap[speciesName];
      const rawValue = formData[speciesName];
      
      if (rawValue !== undefined && rawValue !== '') {
        const raw = parseFloat(rawValue) || 0;
        
        // Check if ct value >= 35, if so use 0 multiplier
        if (raw >= 35) {
          // Use 0 multiplier, so contribution is 0
          sum += 0;
        } else {
          // Check if species is in harmful list
          const isHarmful = macronutrient_harmfulsp.includes(speciesName);
          
          // Get score_cal for this species
          const scoreCal = getScoreCal(speciesName, raw);
          // Get multiplier based on score_cal and harmful status
          const multiplier = getMultiplier(scoreCal, isHarmful);
          // Calculate: multiplier * species_value (can be negative for some species)
          const contribution = multiplier * speciesValue;
          sum += contribution;
        }
      }
    });

    // Store the calculated sum
    macronutrientResults[macronutrientName] = sum.toFixed(2);

    // Find matching condition to get score
    const config = macronutrient_spCondition[macronutrientName];
    if (config && Array.isArray(config.conditions)) {
      const matched = config.conditions.find(c => c.condition(sum));
      if (matched) {
        macronutrientScores[macronutrientName] = matched.score;
      }
    }
  });

  return { scores: macronutrientScores, results: macronutrientResults };
};

// Updated formula-based calculation for disease score using value_use and typeofbacteria_qpt
const calculateStaticAsthma = (formData, config, reportModeParam) => {
  const getScore = (label) => {
    const raw = parseFloat(formData[label]) || 0;

    // Use the reportModeParam passed in (from component closure), never module-level reportMode
    const metaSource =
      reportModeParam === '9P'
        ? bacteriaMetaConfig_9P
        : reportModeParam === 'Allergy and Skin'
        ? bacteriaMetaConfig_allergy
        : reportModeParam === 'Allergy and Skin_kids'
        ? bacteriaMetaConfig_allergy_kids
        : reportModeParam === 'Toxin'
        ? bacteriaMetaConfig_toxin
        : reportModeParam === 'oms'
        ? bacteriaMetaConfig_oms
        : reportModeParam === 'bwcallergy'
        ? bacteriaMetaConfig_bwcallergy
        : reportModeParam === 'bwccore'
        ? bacteriaMetaConfig_bwccore
        : reportModeParam === 'bwcdiamond'
        ? bacteriaMetaConfig_bwcdiamond
        : bacteriaMetaConfig;

    const meta = metaSource[label];
    if (meta && Array.isArray(meta.rangeMapping)) {
      let matched;
      if (meta.customCondition) {
        matched = meta.rangeMapping.find(r => 
          typeof r.condition === 'function' && evaluateBacteriaCondition(r.condition, raw, formData, label)
        );
      } else {
        matched = meta.rangeMapping.find(r => raw >= r.min && raw <= r.max);
      }
      if (matched && matched.score_cal !== undefined) {
        return matched.score_cal;
      }
    }
    return 0;
  };

  // Get the number of bacteria being used (n)
  const n = config.value_use ? config.value_use.length : 0;
  
  // Calculate sum of absolute differences from score 3
  let sumDifferences = 0;
  const bacteriaScores = [];
  
  // Only show detailed logs for Asthma
  const isAsthma = config.match_key === 'Asthma' || 
                   (config.titel && typeof config.titel === 'string' && config.titel.includes('Asthma')) ||
                   (config.titel && Array.isArray(config.titel) && config.titel.some(t => t.includes('Asthma')));
  
  if (isAsthma) {
    console.log('=== Asthma Score Calculation (UPDATED) ===');
    console.log('Timestamp:', new Date().toISOString());
    console.log('Universal bacteria:', formData['Universal bacteria']);
    console.log('Number of bacteria (n):', n);
    console.log('Config value_use:', config.value_use);
  }
  
  config.value_use.forEach((bacteria, index) => {
    const score_cal = getScore(bacteria);
    const difference = Math.abs(score_cal - 3);
    const rawValue = parseFloat(formData[bacteria]) || 0;
    
    bacteriaScores.push({
      bacteria,
      rawValue,
      score_cal,
      difference
    });
    
    sumDifferences += difference;
    
    if (isAsthma) {
      console.log(`${index + 1}. ${bacteria}:`);
      console.log(`   Raw value: ${rawValue}`);
      console.log(`   Score_cal: ${score_cal}`);
      console.log(`   |${score_cal} - 3| = ${difference}`);
    }
  });
  
  if (isAsthma) {
    console.log('Sum of differences:', sumDifferences);
    
    // Apply the formula: โ(9 ร— ฮฃ|si - 3|)/(2n)โ + 1
    const multipliedSum = 9 * sumDifferences;
    console.log('9 ร— sumDifferences:', multipliedSum);
    
    const dividedResult = multipliedSum / (2 * n);
    console.log('Divided by 2n:', dividedResult);
    
    const ceilingResult = Math.ceil(dividedResult);
    console.log('Ceiling result:', ceilingResult);
    
    let finalScore = ceilingResult + 1;
    
    // Cap the maximum score at 10
    if (finalScore > 10) {
      console.log('Score capped at 10 (original score was:', finalScore, ')');
      finalScore = 10;
    }
    
    console.log('Final score:', finalScore);
    console.log('===============================');
  }
  
  // Apply the formula: โ(9 ร— ฮฃ|si - 3|)/(2n)โ + 1
  const multipliedSum = 9 * sumDifferences;
  const dividedResult = multipliedSum / (2 * n);
  const ceilingResult = Math.ceil(dividedResult);
  let finalScore = ceilingResult + 1;
  
  // Cap the maximum score at 10
  if (finalScore > 10) {
    finalScore = 10;
  }
  
  return finalScore;
};

  // Reset positions ready when formData or version changes
  useEffect(() => {
    setPositionsReady(false);
  }, [formData, useThaiVersion]);

  // Calculate when modal opens
  useEffect(() => {
    const newResults = {};
    const newScores = {};

    const numericValues = Object.entries(formData)
        .filter(([key, value]) => typeof value === 'string' && !isNaN(parseFloat(value)))
        .map(([_, value]) => parseFloat(value));

        if (numericValues.length > 0) {
        const sum = numericValues.reduce((a, b) => a + b, 0);
        setAverage((sum / numericValues.length).toFixed(2));
        }

        const metaSource =
        reportMode === '9P'
          ? bacteriaMetaConfig_9P
          : reportMode === 'Allergy and Skin'
          ? bacteriaMetaConfig_allergy
          : reportMode === 'Toxin'
          ? bacteriaMetaConfig_toxin
          : reportMode === 'oms'
          ? bacteriaMetaConfig_oms
          : reportMode === 'bwcallergy'
          ? bacteriaMetaConfig_bwcallergy
          : reportMode === 'bwccore'
          ? bacteriaMetaConfig_bwccore
          : reportMode === 'bwcdiamond'
          ? bacteriaMetaConfig_bwcdiamond
          : bacteriaMetaConfig;

        Object.entries(metaSource).forEach(([label, meta]) => {
          const rawValue = formData[label];
          const x = rawValue !== undefined && rawValue !== '' ? parseFloat(rawValue) : 0;
        
          if (!isNaN(x)) {
            try {
              const calc = eval(meta.formula); // eslint-disable-line no-eval
              newResults[label] = calc.toFixed(2);
        
              let matched;
              if (meta.customCondition) {
                // Use custom condition functions (e.g., for Akkermansia muciniphila)
                const _universalBacteria = parseFloat(formData['Universal bacteria']) || 0; // eslint-disable-line no-unused-vars
                // console.log('Custom condition evaluation:', {
                //   label,
                //   calc,
                //   universalBacteria,
                //   difference: calc - universalBacteria,
                //   formDataKeys: Object.keys(formData)
                // });
                matched = meta.rangeMapping.find(r => 
                  typeof r.condition === 'function' && evaluateBacteriaCondition(r.condition, calc, formData, label)
                );
              } else {
                matched = meta.rangeMapping.find(r => calc >= r.min && calc <= r.max);
              }
              if (matched) {
                // Use score_cal for visual position instead of score
                newScores[label] = matched.score_cal;
                // console.log(`Score for ${label}:`, {
                //   value: calc,
                //   matchedRange: matched,
                //   visualScore: matched.score_cal,
                //   calculationScore: matched.score
                // });
              }
            } catch (err) {
              newResults[label] = 'Invalid';
            }
          }
        });         

    setResults(newResults);
    setScores(newScores);
    
    // Calculate vitamin B scores (only for QPT format)
    if (reportMode === 'QPT') {
      const { scores: vbScores, results: vbResults } = calculateVitaminBScores(formData, reportMode);
      setVitaminBScores(vbScores);
      setVitaminBResults(vbResults);
      
      // Calculate neurotransmitter scores
      const { scores: ntScores, results: ntResults } = calculateNeurotransmitterScores(formData, reportMode);
      setNeurotransmitterScores(ntScores);
      setNeurotransmitterResults(ntResults);
      
      // Calculate metabolites scores
      const { scores: mtScores, results: mtResults } = calculateMetabolitesScores(formData, reportMode);
      setMetabolitesScores(mtScores);
      setMetabolitesResults(mtResults);
      
      // Calculate macronutrient scores
      const { scores: mnScores, results: mnResults } = calculateMacronutrientScores(formData, reportMode);
      setMacronutrientScores(mnScores);
      setMacronutrientResults(mnResults);
    }
    
    // Set positions ready after calculations are complete
    setTimeout(() => {
      setPositionsReady(true);
    }, 500);
  }, [formData, reportMode]);

  // eslint-disable-next-line no-unused-vars
  const getNeedleStyle = () => {
    const avg = parseFloat(average);
    const range = rotationRanges.find(r => avg >= r.min && avg <= r.max);
  
    return {
      transform: `translateX(-50%) rotate(${range?.rotation || '0deg'})`,
      top: range?.top || '275px',
      left: range?.left || '50%',
      transformOrigin: range?.transformOrigin || 'center bottom'
    };
  };

  // eslint-disable-next-line no-unused-vars
  const currentRotation = rotationRanges.find(r => average >= r.min && average <= r.max);

  // eslint-disable-next-line no-unused-vars
  const handleSave = async () => {
  try {
    const pages = document.querySelectorAll('.pdf-page-wrapper');
    if (!pages.length) {
      alert('No PDF content to export.');
      return;
    }

    const jsPDF = (await import('jspdf')).jsPDF;
    const html2canvas = (await import('html2canvas')).default;

    const pdf = new jsPDF('p', 'mm', 'a4');
    let isFirst = true;

    for (let i = 0; i < pages.length; i++) {
      const el = pages[i];
      el.scrollIntoView(); // Ensure render

      await new Promise(r => setTimeout(r, 100)); // Wait for image layout

      const canvas = await html2canvas(el, {
        scale: 1.9,
        useCORS: true,
        backgroundColor: '#fff'
      });

      const imgData = canvas.toDataURL('image/jpeg', 0.90);
      const pdfWidth = pdf.internal.pageSize.getWidth();
      const imgHeight = (canvas.height * pdfWidth) / canvas.width;

      if (!isFirst) pdf.addPage();
      pdf.addImage(imgData, 'JPEG', 0, 0, pdfWidth, imgHeight);
      isFirst = false;
    }

    // Convert to blob and upload
    const blob = pdf.output('blob');
    const file = new File(
      [blob],
      `${formData['Report Number'] || 'report'}.pdf`,
      { type: 'application/pdf' }
    );

    const formDataUpload = new FormData();
    formDataUpload.append('pdf', file);

    await axios.post(`${process.env.REACT_APP_API_BASE}/api/pdf/upload`, formDataUpload, {
      headers: { 'Content-Type': 'multipart/form-data' }
    });

    alert('PDF saved successfully to server.');
  } catch (err) {
    console.error(err);
    alert('Failed to save PDF to server.');
  }
};


  const getDiseaseResultImage = (disease) => {
    const labelKey = Array.isArray(disease.label) ? disease.label.join(' ') : disease.label;
    let scoreSource =
      reportMode === '9P'
        ? scoreConfig_AllergyandEczema_9P.find(cfg => cfg.match_key === labelKey)
        : reportMode === 'Allergy and Skin'
        ? scoreConfig_AllergyandEczema_allergy.find(cfg => cfg.match_key === labelKey)
        : reportMode === 'Allergy and Skin_kids'
        ? scoreConfig_AllergyandEczema_allergy_kids.find(cfg => cfg.match_key === labelKey)
        : reportMode === 'Toxin'
        ? scoreConfig_AllergyandEczema_toxin.find(cfg => cfg.match_key === labelKey)
        : reportMode === 'oms'
        ? scoreConfig_AllergyandEczema_oms.find(cfg => cfg.match_key === labelKey)
        : reportMode === 'bwcallergy'
        ? scoreConfig_AllergyandEczema_bwcallergy.find(cfg => cfg.match_key === labelKey)
        : reportMode === 'bwccore'
        ? scoreConfig_AllergyandEczema_bwccore.find(cfg => cfg.match_key === labelKey)
        : reportMode === 'bwcdiamond'
        ? scoreConfig_AllergyandEczema_bwcdiamond.find(cfg => cfg.match_key === labelKey)
        : useThaiVersion
        ? scoreConfig_AllergyandEczema_thai.find(cfg => cfg.match_key === labelKey)
        : scoreConfig_AllergyandEczema.find(cfg => cfg.match_key === labelKey);
  
    // Fallback to QPT config if the current-mode config doesn't have this disease
    if (!scoreSource) {
      scoreSource = scoreConfig_AllergyandEczema.find(cfg => cfg.match_key === labelKey);
    }

    if (scoreSource && scoreSource.formula === 'static_asthma_score') {
      try {
        const score = calculateStaticAsthma(formData, scoreSource, reportMode);
        // Treat missing/invalid score as 1 (Low) so the disease icon always renders
        const validScore = (score === null || score === undefined || isNaN(score)) ? 1 : score;
        const match = disease.result_comp.find(r => validScore >= r.min && validScore <= r.max);
        // If still no range match, fall back to the first (Low) range
        return (match ?? disease.result_comp[0])?.image ?? null;
      } catch (err) {
        console.error('Error calculating disease score for:', labelKey, err);
        return disease.result_comp[0]?.image ?? null;
      }
    }
  
    if (disease.value_use && disease.formula) {
      const values = disease.value_use.map((label, index) => {
        const raw = formData[label];
        const val = raw !== undefined && raw !== '' ? parseFloat(raw) : 0;
        return { [`order${index + 1}`]: val };
      });
  
      const valueMap = Object.assign({}, ...values);
  
      try {
        const formulaEval = disease.formula.replace(/order\d+/g, (match) => valueMap[match] || 0);
        const result = eval(formulaEval); // eslint-disable-line no-eval
        const rounded = Number(result.toFixed(2));
        const matched = disease.result_comp.find(r => rounded >= r.min && rounded <= r.max);
        return matched?.image || null;
      } catch (err) {
        console.error(`Error evaluating formula for ${labelKey}:`, err);
        return null;
      }
    }
  
    return null;
  };

  // Helper to get the correct precise text config and helpers based on report mode
  const getPreciseTextHelpers = (reportMode) => {
    if (reportMode === '9P') {
      return {
        pdfTextPreciseConfig: pdfTextPreciseConfig_9P,
        getDeficientBacteriaNames: getDeficientBacteriaNames9P,
        formatBacteriaNames: formatBacteriaNames9P,
        getTextConfigForPage: getTextConfigForPage9P
      };
    } else if (reportMode === 'Allergy and Skin') {
      return {
        pdfTextPreciseConfig: pdfTextPreciseConfig_allergy,
        getDeficientBacteriaNames: getDeficientBacteriaNamesAllergy,
        formatBacteriaNames: formatBacteriaNamesAllergy,
        getTextConfigForPage: getTextConfigForPageAllergy
      };
    } else if (reportMode === 'Allergy and Skin_kids') {
      return {
        pdfTextPreciseConfig: pdfTextPreciseConfig_allergy_kids,
        getDeficientBacteriaNames: getDeficientBacteriaNamesAllergyKids,
        formatBacteriaNames: formatBacteriaNamesAllergyKids,
        getTextConfigForPage: getTextConfigForPageAllergyKids
      };
    } else if (reportMode === 'Toxin') {
      return {
        pdfTextPreciseConfig: pdfTextPreciseConfig_toxin,
        getDeficientBacteriaNames: getDeficientBacteriaNamesToxin,
        formatBacteriaNames: formatBacteriaNamesToxin,
        getTextConfigForPage: getTextConfigForPageToxin
      };
    } else if (reportMode === 'bwcallergy') {
      return {
        pdfTextPreciseConfig: pdfTextPreciseConfig_bwcallergy,
        getDeficientBacteriaNames: getDeficientBacteriaNamesBwcallergy,
        formatBacteriaNames: formatBacteriaNamesBwcallergy,
        getTextConfigForPage: getTextConfigForPageBwcallergy
      };
    } else if (reportMode === 'bwccore') {
      return {
        pdfTextPreciseConfig: pdfTextPreciseConfig_bwccore,
        getDeficientBacteriaNames: getDeficientBacteriaNamesBwccore,
        formatBacteriaNames: formatBacteriaNamesBwccore,
        getTextConfigForPage: getTextConfigForPageBwccore
      };
    } else if (reportMode === 'bwcdiamond') {
      return {
        pdfTextPreciseConfig: pdfTextPreciseConfig_diamond,
        getDeficientBacteriaNames: getDeficientBacteriaNamesDiamond,
        formatBacteriaNames: formatBacteriaNamesDiamond,
        getTextConfigForPage: getTextConfigForPageDiamond
      };
    } else if (reportMode === 'oms') {
      return {
        pdfTextPreciseConfig: pdfTextPreciseConfig_oms,
        getDeficientBacteriaNames: getDeficientBacteriaNamesOms,
        formatBacteriaNames: formatBacteriaNamesOms,
        getTextConfigForPage: getTextConfigForPageOms
      };
    }
    // Default to QPT or other
    return {
      pdfTextPreciseConfig,
      getDeficientBacteriaNames,
      formatBacteriaNames,
      getTextConfigForPage
    };
  };

  return (
    <div className="pdf-preview-overlay">
      <div className="pdf-preview-content scrollable-pdf">
        <div className="pdf-pages-row">
        <div className={`pdf-pages${useThaiVersion ? ' pdf-pages--thai-lang' : ''}`}>
          {[...Array(totalPagesWithOverflow)].map((_, index) => {
            const renderedPageNumber = index + 1;
            // Overflow supplement pages reuse an earlier page's PNG, so the
            // source page (used for the image and every overlay lookup) can
            // differ from the position in the booklet.
            const { source: pageNumber, chunk: supplementChunk } = mapRenderedPage(renderedPageNumber);

            // An overflow supplement page shows only the template plus its own
            // slice of cards โ€” no other overlays are repeated.
            if (supplementChunk > 0) {
              return (
                <div
                  key={`overflow-${renderedPageNumber}`}
                  id={`pdf-preview-page-${renderedPageNumber}`}
                  className="pdf-page-wrapper"
                >
                  <img
                    src={`${process.env.PUBLIC_URL}${resolvedPdfBasePath}/${pageNumber}.jpg`}
                    alt={`Page ${renderedPageNumber}`}
                    className="pdf-page-img"
                  />
                  {renderPageNumber(renderedPageNumber)}
                  {render9PSupplementGrid(
                    supplementsForChunk(supplementChunk),
                    activeSupplementChoosing,
                    renderedPageNumber
                  )}
                </div>
              );
            }

            const formatOverlaySet = imageOverlayConfig[reportMode] || [];
            const currentPageConfig = formatOverlaySet.find(cfg => cfg.page === pageNumber);

            return (
            <div key={index} id={`pdf-preview-page-${renderedPageNumber}`} className="pdf-page-wrapper">
              <img
                src={`${process.env.PUBLIC_URL}${resolvedPdfBasePath}/${pageNumber}.jpg`}
                alt={`Page ${renderedPageNumber}`}
                className="pdf-page-img"
              />
              {renderPageNumber(renderedPageNumber)}

              {/* 9P macronutrient summary result โ€” page 19 (eng) / page 20 (thai) */}
              {macro9P && pageNumber === macro9P.config.page && macro9P.label && (
                <React.Fragment key={`macro9P-${pageNumber}`}>
                  {/* Result label */}
                  <div
                    className="pdf-overlay-text"
                    style={{
                      position: 'absolute',
                      top: macro9P.config.YposText,
                      left: macro9P.config.XposText,
                      color: '#000000',
                      textAlign: 'left',
                      pointerEvents: 'none',
                      zIndex: 5,
                      fontSize: useThaiVersion ? '17px' : '15px',
                      fontFamily: FONT_STACK_MIXED_THAI_LATIN
                    }}
                  >
                    {macro9P.label}
                  </div>

                  {/* Color bars โ€” 5 bars for visual consistency; arrow lands on the matched score (1-3) */}
                  {[1, 2, 3, 4, 5].map((s) => {
                    const barLeft = macro9P.config.xBarStart + macro9P.config.xBarGap * (s - 1);
                    const isMatch = macro9P.score === s;
                    return (
                      <div
                        key={s}
                        className={`score-block score-${s} ${isMatch ? 'active' : ''}`}
                        style={{
                          top: macro9P.config.YBarStart,
                          left: barLeft,
                          position: 'absolute',
                          width: '60px'
                        }}
                      >
                        {isMatch && (
                          <div
                            className="arrow-down"
                            style={{
                              position: 'absolute',
                              left: `${macro9P.config.xBarGap / 2}px`,
                              top: '-7px'
                            }}
                          />
                        )}
                      </div>
                    );
                  })}

                  {/* Result image */}
                  {macro9P.image && (
                    <img
                      src={`${process.env.PUBLIC_URL}/9P/icon_extra/${macro9P.image}.png`}
                      alt={macro9P.label}
                      className="pdf-overlay-image"
                      style={{
                        position: 'absolute',
                        top: macro9P.config.YposImage,
                        left: macro9P.config.XposImage,
                        width: macro9P.config.scale_imageX,
                        height: macro9P.config.scale_imageY,
                        zIndex: 5
                      }}
                      onError={(e) => {
                        console.error('Failed to load 9P macronutrient image:', `/9P/icon_extra/${macro9P.image}.png`);
                        e.target.style.display = 'none';
                      }}
                    />
                  )}
                </React.Fragment>
              )}

              {/* 9P vitamin B biosynthesis result โ€” page 20 (eng) / page 19 (thai) */}
              {vitaminB9P && pageNumber === vitaminB9P.config.page && vitaminB9P.label && (
                <React.Fragment key={`vitaminB9P-${pageNumber}`}>
                  {/* Result label */}
                  <div
                    className="pdf-overlay-text"
                    style={{
                      position: 'absolute',
                      top: vitaminB9P.config.YposText,
                      left: vitaminB9P.config.XposText,
                      color: '#000000',
                      textAlign: 'left',
                      pointerEvents: 'none',
                      zIndex: 5,
                      fontSize: useThaiVersion ? '17px' : '15px',
                      fontFamily: FONT_STACK_MIXED_THAI_LATIN
                    }}
                  >
                    {vitaminB9P.label}
                  </div>

                  {/* Color bars โ€” 5 bars for visual consistency; arrow lands on the matched score (1-3) */}
                  {[1, 2, 3, 4, 5].map((s) => {
                    const barLeft = vitaminB9P.config.xBarStart + vitaminB9P.config.xBarGap * (s - 1);
                    const isMatch = vitaminB9P.score === s;
                    return (
                      <div
                        key={s}
                        className={`score-block score-${s} ${isMatch ? 'active' : ''}`}
                        style={{
                          top: vitaminB9P.config.YBarStart,
                          left: barLeft,
                          position: 'absolute',
                          width: '60px'
                        }}
                      >
                        {isMatch && (
                          <div
                            className="arrow-down"
                            style={{
                              position: 'absolute',
                              left: `${vitaminB9P.config.xBarGap / 2}px`,
                              top: '-7px'
                            }}
                          />
                        )}
                      </div>
                    );
                  })}

                  {/* Result image */}
                  {vitaminB9P.image && (
                    <img
                      src={`${process.env.PUBLIC_URL}/9P/icon_extra/${vitaminB9P.image}.png`}
                      alt={vitaminB9P.label}
                      className="pdf-overlay-image"
                      style={{
                        position: 'absolute',
                        top: vitaminB9P.config.YposImage,
                        left: vitaminB9P.config.XposImage,
                        width: vitaminB9P.config.scale_imageX,
                        height: vitaminB9P.config.scale_imageY,
                        zIndex: 5
                      }}
                      onError={(e) => {
                        console.error('Failed to load 9P vitamin B image:', `/9P/icon_extra/${vitaminB9P.image}.png`);
                        e.target.style.display = 'none';
                      }}
                    />
                  )}
                </React.Fragment>
              )}

              {/* 9P SCFAs result โ€” page 21 (eng) / page 20 (thai) */}
              {scfas9P && pageNumber === scfas9P.config.page && scfas9P.label && (
                <React.Fragment key={`scfas9P-${pageNumber}`}>
                  {/* Result label */}
                  <div
                    className="pdf-overlay-text"
                    style={{
                      position: 'absolute',
                      top: scfas9P.config.YposText,
                      left: scfas9P.config.XposText,
                      color: '#000000',
                      textAlign: 'left',
                      pointerEvents: 'none',
                      zIndex: 5,
                      fontSize: useThaiVersion ? '17px' : '15px',
                      fontFamily: FONT_STACK_MIXED_THAI_LATIN
                    }}
                  >
                    {scfas9P.label}
                  </div>

                  {/* Color bars โ€” 5 bars for visual consistency; arrow lands on the matched score (1-3) */}
                  {[1, 2, 3, 4, 5].map((s) => {
                    const barLeft = scfas9P.config.xBarStart + scfas9P.config.xBarGap * (s - 1);
                    const isMatch = scfas9P.score === s;
                    return (
                      <div
                        key={s}
                        className={`score-block score-${s} ${isMatch ? 'active' : ''}`}
                        style={{
                          top: scfas9P.config.YBarStart,
                          left: barLeft,
                          position: 'absolute',
                          width: '60px'
                        }}
                      >
                        {isMatch && (
                          <div
                            className="arrow-down"
                            style={{
                              position: 'absolute',
                              left: `${scfas9P.config.xBarGap / 2}px`,
                              top: '-7px'
                            }}
                          />
                        )}
                      </div>
                    );
                  })}

                  {/* Result image */}
                  {scfas9P.image && (
                    <img
                      src={`${process.env.PUBLIC_URL}/9P/icon_extra/${scfas9P.image}.png`}
                      alt={scfas9P.label}
                      className="pdf-overlay-image"
                      style={{
                        position: 'absolute',
                        top: scfas9P.config.YposImage,
                        left: scfas9P.config.XposImage,
                        width: scfas9P.config.scale_imageX,
                        height: scfas9P.config.scale_imageY,
                        zIndex: 5
                      }}
                      onError={(e) => {
                        console.error('Failed to load 9P SCFAs image:', `/9P/icon_extra/${scfas9P.image}.png`);
                        e.target.style.display = 'none';
                      }}
                    />
                  )}
                </React.Fragment>
              )}

              {/* 9P Neurotransmitter result โ€” page 22 (eng) / page 21 (thai) */}
              {neuro9P && pageNumber === neuro9P.config.page && neuro9P.label && (
                <React.Fragment key={`neuro9P-${pageNumber}`}>
                  {/* Result label */}
                  <div
                    className="pdf-overlay-text"
                    style={{
                      position: 'absolute',
                      top: neuro9P.config.YposText,
                      left: neuro9P.config.XposText,
                      color: '#000000',
                      textAlign: 'left',
                      pointerEvents: 'none',
                      zIndex: 5,
                      fontSize: useThaiVersion ? '17px' : '15px',
                      fontFamily: FONT_STACK_MIXED_THAI_LATIN
                    }}
                  >
                    {neuro9P.label}
                  </div>

                  {/* Color bars โ€” 5 bars for visual consistency; arrow lands on the matched score (1-3) */}
                  {[1, 2, 3, 4, 5].map((s) => {
                    const barLeft = neuro9P.config.xBarStart + neuro9P.config.xBarGap * (s - 1);
                    const isMatch = neuro9P.score === s;
                    return (
                      <div
                        key={s}
                        className={`score-block score-${s} ${isMatch ? 'active' : ''}`}
                        style={{
                          top: neuro9P.config.YBarStart,
                          left: barLeft,
                          position: 'absolute',
                          width: '60px'
                        }}
                      >
                        {isMatch && (
                          <div
                            className="arrow-down"
                            style={{
                              position: 'absolute',
                              left: `${neuro9P.config.xBarGap / 2}px`,
                              top: '-7px'
                            }}
                          />
                        )}
                      </div>
                    );
                  })}

                  {/* Result image */}
                  {neuro9P.image && (
                    <img
                      src={`${process.env.PUBLIC_URL}/9P/icon_extra/${neuro9P.image}.png`}
                      alt={neuro9P.label}
                      className="pdf-overlay-image"
                      style={{
                        position: 'absolute',
                        top: neuro9P.config.YposImage,
                        left: neuro9P.config.XposImage,
                        width: neuro9P.config.scale_imageX,
                        height: neuro9P.config.scale_imageY,
                        zIndex: 5
                      }}
                      onError={(e) => {
                        console.error('Failed to load 9P Neurotransmitter image:', `/9P/icon_extra/${neuro9P.image}.png`);
                        e.target.style.display = 'none';
                      }}
                    />
                  )}
                </React.Fragment>
              )}

              {/* Render BWC Diamond watermark text on all pages */}
              {reportMode === 'bwcdiamond' && Object.entries(useThaiVersion ? text_allpage_bwcdiamond_thai : text_allpage_bwcdiamond_eng).map(([key, cfg]) => {
                // Map config key to formData field
                const fieldMap = {
                  Full_Name: 'Full Name',
                  Gender: 'Gender',
                  Date_of_Birth: 'Date of Birth',
                  Report_Date: 'Report Date',
                  Collection_Date: 'Collection Date',
                  HN: 'HN'
                };
                
                let value = formData[fieldMap[key]] || '';
                
                // Handle special cases for dates and report date
                if (key === 'Report_Date') {
                  value = formatReportDate(formData[fieldMap[key]], useThaiVersion);
                } else if (key === 'Date_of_Birth' || key === 'Collection_Date') {
                  const rawDate = formData[fieldMap[key]];
                  if (useThaiVersion) {
                    const parsedDate = parseFlexibleDDMMYYYY(rawDate);
                    value = parsedDate ? formatDateThai(parsedDate) : 'N/A';
                  } else {
                    const parsedDate = parseFlexibleDDMMYYYY(rawDate);
                    value = parsedDate
                      ? parsedDate.toLocaleDateString('en-GB', {
                          day: 'numeric',
                          month: 'long',
                          year: 'numeric'
                        })
                      : 'N/A';
                  }
                } else if (key === 'Gender' && useThaiVersion) {
                  value = translateGender(formData[fieldMap[key]]);
                }
                
                if (!value || value === 'N/A') return null;
                
                return (
                  <div
                    key={`bwc-diamond-watermark-${key}-${pageNumber}`}
                    className="pdf-overlay-text"
                    style={{
                      position: 'absolute',
                      top: `${cfg.Ypos}px`,
                      left: `${cfg.Xpos}px`,
                      fontSize: `${cfg.fontSize}px`,
                      fontWeight: cfg.fontWeight,
                      color: cfg.color,
                      // opacity: 0.6, // increased opacity to make color more visible
                      pointerEvents: 'none',
                      zIndex: 2,
                      fontFamily: FONT_STACK_MIXED_THAI_LATIN
                    }}
                  >
                    {cfg.format || ''}{value}
                  </div>
                );
              })}
              
              {/* Render BWC Allergy watermark text on all pages */}
              {reportMode === 'bwcallergy' && Object.entries(useThaiVersion ? text_allpage_bwcallergy_thai : text_allpage_bwcallergy_eng).map(([key, cfg]) => {
                // Map config key to formData field
                const fieldMap = {
                  Full_Name: 'Full Name',
                  Gender: 'Gender',
                  Date_of_Birth: 'Date of Birth',
                  Report_Date: 'Report Date',
                  Collection_Date: 'Collection Date',
                  HN: 'HN'
                };
                
                let value = formData[fieldMap[key]] || '';
                
                // Handle special cases for dates and report date
                if (key === 'Report_Date') {
                  value = formatReportDate(formData[fieldMap[key]], useThaiVersion);
                } else if (key === 'Date_of_Birth' || key === 'Collection_Date') {
                  const rawDate = formData[fieldMap[key]];
                  if (useThaiVersion) {
                    const parsedDate = parseFlexibleDDMMYYYY(rawDate);
                    value = parsedDate ? formatDateThai(parsedDate) : 'N/A';
                  } else {
                    const parsedDate = parseFlexibleDDMMYYYY(rawDate);
                    value = parsedDate
                      ? parsedDate.toLocaleDateString('en-GB', {
                          day: 'numeric',
                          month: 'long',
                          year: 'numeric'
                        })
                      : 'N/A';
                  }
                } else if (key === 'Gender' && useThaiVersion) {
                  value = translateGender(formData[fieldMap[key]]);
                }
                
                if (!value || value === 'N/A') return null;
                
                return (
                  <div
                    key={`bwc-allergy-watermark-${key}-${pageNumber}`}
                    className="pdf-overlay-text"
                    style={{
                      position: 'absolute',
                      top: `${cfg.Ypos}px`,
                      left: `${cfg.Xpos}px`,
                      fontSize: `${cfg.fontSize}px`,
                      fontWeight: cfg.fontWeight,
                      color: cfg.color,
                      // opacity: 0.6, // increased opacity to make color more visible
                      pointerEvents: 'none',
                      zIndex: 2,
                      fontFamily: FONT_STACK_MIXED_THAI_LATIN
                    }}
                  >
                    {cfg.format || ''}{value}
                  </div>
                );
              })}
              
              {/* Render BWC Core watermark text on all pages */}
              {reportMode === 'bwccore' && Object.entries(useThaiVersion ? text_allpage_bwccore_thai : text_allpage_bwccore_eng).map(([key, cfg]) => {
                // Map config key to formData field
                const fieldMap = {
                  Full_Name: 'Full Name',
                  Gender: 'Gender',
                  Date_of_Birth: 'Date of Birth',
                  Report_Date: 'Report Date',
                  Collection_Date: 'Collection Date',
                  HN: 'HN'
                };
                
                let value = formData[fieldMap[key]] || '';
                
                // Handle special cases for dates and report date
                if (key === 'Report_Date') {
                  value = formatReportDate(formData[fieldMap[key]], useThaiVersion);
                } else if (key === 'Date_of_Birth' || key === 'Collection_Date') {
                  const rawDate = formData[fieldMap[key]];
                  if (useThaiVersion) {
                    const parsedDate = parseFlexibleDDMMYYYY(rawDate);
                    value = parsedDate ? formatDateThai(parsedDate) : 'N/A';
                  } else {
                    const parsedDate = parseFlexibleDDMMYYYY(rawDate);
                    value = parsedDate
                      ? parsedDate.toLocaleDateString('en-GB', {
                          day: 'numeric',
                          month: 'long',
                          year: 'numeric'
                        })
                      : 'N/A';
                  }
                } else if (key === 'Gender' && useThaiVersion) {
                  value = translateGender(formData[fieldMap[key]]);
                }
                
                if (!value || value === 'N/A') return null;
                
                return (
                  <div
                    key={`bwc-core-watermark-${key}-${pageNumber}`}
                    className="pdf-overlay-text"
                    style={{
                      position: 'absolute',
                      top: `${cfg.Ypos}px`,
                      left: `${cfg.Xpos}px`,
                      fontSize: `${cfg.fontSize}px`,
                      fontWeight: cfg.fontWeight,
                      color: cfg.color,
                      // opacity: 0.6, // increased opacity to make color more visible
                      pointerEvents: 'none',
                      zIndex: 2,
                      fontFamily: FONT_STACK_MIXED_THAI_LATIN
                    }}
                  >
                    {cfg.format || ''}{value}
                  </div>
                );
              })}
              
              {/* Render text_all_qpt images with conditions */}
              {(() => {
                // Show on all pages for Thai version, but exclude first page for English version
                const shouldShow = useThaiVersion ? true : pageNumber !== 1;
                
                if (!shouldShow) return null;
                
                return text_all_qpt.map((imgConfig, idx) => (
                  <img
                    key={`all-qpt-${idx}-${pageNumber}`}
                    src={`${process.env.PUBLIC_URL}/${imgConfig.img}.png`}
                    alt={imgConfig.img}
                    className="pdf-overlay-image"
                    style={{
                      position: 'absolute',
                      top: `${imgConfig.Ypos_img}px`,
                      left: `${imgConfig.Xpos_img}px`,
                      width: `${imgConfig.width_img}px`,
                      height: 'auto',
                      zIndex: 5
                    }}
                  />
                ));
              })()}
              
              {/* Render report number with conditions - for QPT, 9P, Allergy and Skin, Toxin, and OMS formats */}
              {(reportMode === 'QPT' || reportMode === '9P' || reportMode === 'Allergy and Skin' || reportMode === 'Allergy and Skin_kids' || reportMode === 'Toxin' || reportMode === 'oms') && (() => {
                let configArray;
                if (reportMode === 'QPT') {
                  configArray = reportnumber_all_qpt;
                } else if (reportMode === '9P') {
                  configArray = reportnumber_all_9P;
                } else if (reportMode === 'Allergy and Skin') {
                  configArray = reportnumber_all_allergy;
                } else if (reportMode === 'Allergy and Skin_kids') {
                  configArray = reportnumber_all_allergy_kids;
                } else if (reportMode === 'Toxin') {
                  configArray = reportnumber_all_toxin;
                } else if (reportMode === 'oms') {
                  configArray = reportnumber_all_oms;
                }
                
                return configArray.map((config, idx) => {
                  // Handle not_showing property for QPT, 9P, Allergy and Skin, Toxin, and OMS formats
                  let shouldShow = true;
                  
                  if (config.not_showing) {
                    if (config.not_showing === 'none') {
                      shouldShow = true; // Show on all pages
                    } else if (Array.isArray(config.not_showing)) {
                      shouldShow = !config.not_showing.includes(pageNumber); // Hide on specified pages
                    }
                  }
                  
                  if (!shouldShow) return null;
                  
                  return (
                    <div
                      key={`report-number-${reportMode}-${idx}-${pageNumber}`}
                      className="pdf-overlay-text"
                      style={{
                        position: 'absolute',
                        top: `${config.Ypos_img}px`,
                        left: `${config.Xpos_img}px`,
                        fontSize: config.fontSize,
                        fontWeight: config.fontWeight,
                        color: '#333',
                        zIndex: 5,
                        fontFamily: FONT_STACK_MIXED_THAI_LATIN
                      }}
                    >
                      {formData['Report number'] || formData.report_number || formData['Report Number'] || 'N/A'}
                    </div>
                  );
                });
              })()}
              
              {currentPageConfig?.images
                .filter(img => {
                  // Filter out images that don't have a source for the current language
                  const src = typeof img.src === 'string'
                    ? img.src
                    : (useThaiVersion ? img.src.thai : img.src.eng);
                  return src; // Only render if src exists for current language
                })
                .map((img, idx) => {
                  if (img.dynamic) {
                    // if (img.key === 'needle') {
                    //   return (
                    //     <img
                    //       key={idx}
                    //       src={`${process.env.PUBLIC_URL}${img.src}`}
                    //       alt={img.key}
                    //       className="pdf-overlay-image"
                    //       style={{
                    //         position: 'absolute',
                    //         width: '180px',
                    //         zIndex: 5,
                    //         ...getNeedleStyle()
                    //       }}
                    //     />
                    //   );
                    // }
                    return null;
                  }

                  const src = typeof img.src === 'string'
                    ? img.src
                    : (useThaiVersion ? img.src.thai : img.src.eng);

                  if (!src) return null;

                  const fullSrc = `${process.env.PUBLIC_URL}${src}`;

                  const top = typeof img.style.top === 'object'
                    ? useThaiVersion ? img.style.top.thai : img.style.top.eng
                    : img.style.top;

                  const width = typeof img.style.width === 'object'
                    ? useThaiVersion ? img.style.width.thai : img.style.width.eng
                    : img.style.width;

                  return (
                    <img
                      key={idx}
                      src={fullSrc}
                      alt={img.key}
                      className="pdf-overlay-image"
                      style={{
                        position: 'absolute',
                        top,
                        left: img.style.left,
                        width,
                        height: 'auto',
                        zIndex: 5,
                        ...(img.style.transform ? { transform: img.style.transform } : {})
                      }}
                    />
                  );
                })}

                {[...activeDiseases, ...activeDiseasesImage]
                  .filter(d => d.page === pageNumber)
                  .map((disease, i) => {
                  const imageName = getDiseaseResultImage(
                    diseases.find(d => d.label === disease.label) || disease
                  );
                  if (!imageName) return null;

                  return (
                    <React.Fragment key={i}>
                      <img
                        src={`${process.env.PUBLIC_URL}/diseases_icon/${imageName}.png`}
                        alt={disease.label}
                        className="pdf-overlay-image"
                        style={{
                          position: 'absolute',
                          top: disease.Ypos_image,
                          left: disease.Xpos_image,
                          width: disease.width || '100px',
                          height: disease.height || 'auto',
                          zIndex: 5
                        }}
                      />
                      
                      {/* โ… Show label if Xlabel and Ylabel are defined */}
                      {disease.Xlabel && disease.Ylabel && (
                        <div
                          className="pdf-overlay-text"
                          style={{
                            position: 'absolute',
                            top: disease.Ylabel,
                            left: disease.Xlabel,
                            fontSize: '13px',
                            fontWeight: 400,
                            color: '#333',
                            textAlign: 'center',
                            lineHeight: '1.4',
                            fontFamily: FONT_STACK_MIXED_THAI_LATIN
                          }}
                        >
                        {Array.isArray(disease.label_show) ? (
                          disease.label_show.map((line, idx) => (
                            <div
                              key={idx}
                              style={{
                                fontFamily: FONT_STACK_MIXED_THAI_LATIN
                              }}
                            >
                              {line}
                            </div>
                          ))
                        ) : (
                          <div
                            style={{
                              fontFamily: FONT_STACK_MIXED_THAI_LATIN
                            }}
                          >
                            {disease.label_show}
                          </div>
                        )}
                        </div>
                      )}
                    </React.Fragment>
                  );                  
                })}

                {(reportMode === '9P'
                  ? scoreConfig_AllergyandEczema_9P
                  : reportMode === 'Allergy and Skin'
                  ? scoreConfig_AllergyandEczema_allergy
                  : reportMode === 'Allergy and Skin_kids'
                  ? scoreConfig_AllergyandEczema_allergy_kids
                  : reportMode === 'Toxin'
                  ? scoreConfig_AllergyandEczema_toxin
                  : reportMode === 'oms'
                  ? scoreConfig_AllergyandEczema_oms
                  : reportMode === 'bwcallergy'
                  ? scoreConfig_AllergyandEczema_bwcallergy
                  : reportMode === 'bwccore'
                  ? scoreConfig_AllergyandEczema_bwccore
                  : reportMode === 'bwcdiamond'
                  ? scoreConfig_AllergyandEczema_bwcdiamond
                  : useThaiVersion
                  ? scoreConfig_AllergyandEczema_thai
                  : scoreConfig_AllergyandEczema
                ).map((config, index) => {

                  if (config.page !== pageNumber) return null;

                  const score = config.formula === 'static_asthma_score'
                    ? calculateStaticAsthma(formData, config, reportMode)
                    : 0;

                  // Replace score of 0 with 1
                  const adjustedScore = score === 0 ? 1 : score;
                  const matched = config.table_socre.find(r => adjustedScore >= r.min && adjustedScore <= r.max);

                  console.log('Score Calculation:', {
                    title: config.titel,
                    match_key: config.match_key,
                    page: config.page,
                    rawScore: score,
                    adjustedScore: adjustedScore,
                    matchedRange: matched,
                    value_use: config.value_use,
                    formula: config.formula
                  });

                  // Add debugging for image display - only for Asthma
                  const isAsthma = config.match_key === 'Asthma' || 
                                   (config.titel && typeof config.titel === 'string' && config.titel.includes('Asthma')) ||
                                   (config.titel && Array.isArray(config.titel) && config.titel.some(t => t.includes('Asthma')));
                  
                  if (isAsthma && config.formula === 'static_asthma_score') {
                    console.log('๐–ผ๏ธ Image Display Debug:');
                    console.log('  - Raw score:', score);
                    console.log('  - Adjusted score:', adjustedScore);
                    console.log('  - Image source:', `score_${adjustedScore}.png`);
                    console.log('  - Matched range:', matched);
                  }

                  return (
                    <React.Fragment key={index}>
                      {/* Score Image */}
                      <img
                        src={`${process.env.PUBLIC_URL}/score_image/score_${adjustedScore}.png`}
                        alt={`Score ${adjustedScore}`}
                        className="pdf-overlay-image"
                        style={{
                          position: 'absolute',
                          top: `${config.Yimagepos || config.Ydotpos}px`,
                          left: `${config.Ximagepos || config.Xdotpos}px`,
                          width: `${config.width_i || 100}px`,
                          height: `${config.height_i || 'auto'}px`,
                          zIndex: 5
                        }}
                      />

                      {config.number_show !== false && (
                        <>
                          {/* <div
                            style={{
                              position: 'absolute',
                              top: `${config.Ynumberpos}px`,
                              left: `${config.Xnumberpos}px`,
                              width: '60px',
                              height: '60px',
                              borderRadius: '50%',
                              border: `3px solid ${matched?.color_dot}`,
                              display: 'flex',
                              alignItems: 'center',
                              justifyContent: 'center',
                              fontWeight: 500,
                              fontSize: '38px',
                              color: '#000',
                              zIndex: 5
                            }}
                          >
                            {score}
                          </div> */}

                          {useThaiVersion ? (
                            <div
                              style={{
                                position: 'absolute',
                                top: `${config.Ytextpos}px`,
                                left: `${config.Xtextpos}px`,
                                fontSize: '14px',
                                fontWeight: 700,
                                color: matched?.color_dot,
                                zIndex: 5,
                                width: `${config.width_i}px`,
                                textAlign: 'left',
                                fontFamily: FONT_STACK_MIXED_THAI_LATIN
                              }}
                            >
                              {matched?.label}
                            </div>
                          ) : (
                            <div
                              style={{
                                position: 'absolute',
                                top: `${config.Ytextpos}px`,
                                left: `${config.Xtextpos}px`,
                                fontSize: '14px',
                                fontWeight: 700,
                                color: matched?.color_dot,
                                zIndex: 5,
                                width: `${config.width_i}px`,
                                textAlign: 'left',
                                fontFamily: FONT_STACK_MIXED_THAI_LATIN
                              }}
                            >
                              {matched?.label}
                            </div>
                          )}
                        </>
                      )}
                    </React.Fragment>
                  );
                })}

                {
                  (reportMode === '9P'
                    ? (useThaiVersion ? symbol_status_9P_thai : symbol_status_9P_eng)
                    : reportMode === 'Allergy and Skin'
                    ? (useThaiVersion ? symbol_status_thai_allergy : symbol_status_allergy)
                    : reportMode === 'Allergy and Skin_kids'
                    ? (useThaiVersion ? symbol_status_thai_allergy_kids : symbol_status_allergy_kids)
                    : reportMode === 'Toxin'
                    ? (useThaiVersion ? symbol_status_toxin_thai : symbol_status_toxin_eng)
                    : reportMode === 'oms'
                    ? (useThaiVersion ? symbol_status_oms.thai : symbol_status_oms.eng)
                    : reportMode === 'bwcallergy'
                    ? (useThaiVersion ? symbol_status_bwcallergy_thai : symbol_status_bwcallergy_eng)
                    : reportMode === 'bwccore'
                    ? (useThaiVersion ? symbol_status_bwccore_thai : symbol_status_bwccore_eng)   
                    : reportMode === 'bwcdiamond'
                    ? (useThaiVersion ? symbol_status_bwcdiamond_thai : symbol_status_bwcdiamond_eng)
                    : (reportMode === 'QPT' && useThaiVersion ? symbol_status_thai : symbol_status)
                  ).map((config, index) => {

                  if (config.page !== pageNumber) return null;

                  const raw = formData[config.title];
                  // Get the label from bacteriaMetaConfig
                  const bacteriaConfig = bacteriaMetaConfig[config.title];
                  if (!bacteriaConfig) {
                    // console.log('No bacteria config found for:', config.title);
                    return null;
                  }

                  // Find the matching range based on the raw value
                  const matchingRange = bacteriaConfig.rangeMapping.find(range => 
                    typeof range.condition === 'function' && evaluateBacteriaCondition(range.condition, raw, formData, config.title)
                  );
                  if (!matchingRange) {
                    console.log('No matching range found for:', config.title, 'value:', raw);
                    return null;
                  }

                  // Use the label from the matching range to find the status mapping
                  const match = config.status_mapping.find(r => r.result === matchingRange.label);
                  // console.log('Status check:', {
                  //   title: config.title,
                  //   rawValue: raw,
                  //   label: matchingRange.label,
                  //   match: match
                  // });
                  if (!match) return null;

                  return (
                    <img
                      key={index}
                      src={`${process.env.PUBLIC_URL}/icons/${match.img}.png`}
                      alt={match.img}
                      className="pdf-overlay-image"
                      style={{
                        position: 'absolute',
                        top: `${config.Ypos_img}px`,
                        left: `${config.Xpos_img}px`,
                        width: config.width_image ? `${config.width_image}px` : (reportMode === '9P' ? `${width_9P.width_i}px` : reportMode === 'oms' ? `${width_oms.width_i}px` : reportMode === 'Toxin' ? `${width_toxin.width_i}px` : reportMode === 'bwcdiamond' ? `${width_bwcdiamond.width_i}px` : reportMode === 'bwcallergy' ? `${width_bwcallergy.width_i}px` : reportMode === 'bwccore' ? `${width_bwccore.width_i}px` : '20px'),
                        height: 'auto',
                        zIndex: 5
                      }}
                    />
                  );
                })}

                {/* Text Config Section */}
                {(reportMode === 'QPT' 
                  ? (useThaiVersion ? pdfTextConfig_thai : pdfTextConfig)
                  : []  // Return empty array for non-QPT modes
                ).filter(config => config.page === pageNumber).map((config, index) => {
                  // Step 1: Get highest score among value_comparing
                  let maxScore = 0;

                  config.value_comparing.forEach(key => {
                    const matched = scoreConfig_AllergyandEczema.find(item => item.match_key === key);

                    if (matched && matched.formula === 'static_asthma_score') {
                      const score = calculateStaticAsthma(formData, matched, reportMode);
                      if (score > maxScore) maxScore = score;
                    }
                  });

                  const match = config.mapping_text.find(r => maxScore >= r.min && maxScore <= r.max);
                  if (!match) return null;

                  return (
                    <React.Fragment key={index}>
                      <img
                        src={`${process.env.PUBLIC_URL}/status_rate/${useThaiVersion ? 'thai' : 'eng'}/${match.img}.png`}
                        alt={match.label}
                        className="pdf-overlay-image"
                        style={{
                          position: 'absolute',
                          top: `${match.posY_image || config.posY_image}px`,
                          left: `${match.posX_image || config.posX_image}px`,
                          width: match.img === 'low_r' || match.img === 'moderate_r' || match.img === 'high_r' 
                            ? `${image_size_qpt.find(size => size.image_name === match.img)?.width_image || 100}px`
                            : '100px',
                          height: match.img === 'low_r' || match.img === 'moderate_r' || match.img === 'high_r'
                            ? `${image_size_qpt.find(size => size.image_name === match.img)?.height_image || 'auto'}px`
                            : 'auto',
                          zIndex: 5
                        }}
                      />

                      {/* Result Label */}
                      <div
                        className="pdf-overlay-text"
                        style={{
                          position: 'absolute',
                          top: `${match.posY_text || config.posY_text}px`,
                          left: `${match.posX_text || config.posX_text}px`,
                          fontSize: '14px',
                          fontWeight: 700,
                          color: '#333',
                          lineHeight: '1.5',
                          textAlign: 'left',
                          maxWidth: '400px',
                          zIndex: 5,
                          fontFamily: match.fontFamily || (FONT_STACK_MIXED_THAI_LATIN)
                        }}
                      >
                        {(() => {
                          if (Array.isArray(match.label)) {
                            return (
                              <>
                                {match.label.map((line, index) => {
                                  // Check for risk level keywords in each line (both Thai and English)
                                  const keywordMatch = line.match(/(low|moderate|high) risk|(เธฃเธฐเธ”เธฑเธเธ•เนเธณ|เธฃเธฐเธ”เธฑเธเธเธฒเธเธเธฅเธฒเธ|เธฃเธฐเธ”เธฑเธเธชเธนเธ)/i);
                                  if (keywordMatch) {
                                    const keyword = keywordMatch[0];
                                    const [before, after] = line.split(keyword);
                                    return (
                                      <div key={index}>
                                        {before}
                                        <span style={{ color: match.color_dot, fontWeight: 700 }}>{keyword}</span>
                                        {after}
                                      </div>
                                    );
                                  }
                                  return <div key={index}>{line}</div>;
                                })}
                              </>
                            );
                          }

                          // Handle single string format
                          const keywordMatch = match.label.match(/(low|moderate|high) risk|(เธฃเธฐเธ”เธฑเธเธ•เนเธณ|เธฃเธฐเธ”เธฑเธเธเธฒเธเธเธฅเธฒเธ|เธฃเธฐเธ”เธฑเธเธชเธนเธ)/i);
                          const keyword = keywordMatch ? keywordMatch[0] : '';
                          const [before, after] = match.label.split(keyword);

                          return (
                            <>
                              <div>
                                {before}
                                <span style={{ color: match.color_dot, fontWeight: 700 }}>{keyword}</span>
                                {after}
                              </div>
                            </>
                          );
                        })()}
                      </div>

                      {/* Second Label (label_2) - For both English and Thai versions */}
                      {match.label_2 && (
                        <div
                          className="pdf-overlay-text"
                          style={{
                            position: 'absolute',
                            top: `${match.Ylabel_2}px`,
                            left: `${match.Xlabel_2}px`,
                            fontSize: '18px',
                            fontWeight: 400,
                            color: '#333',
                            lineHeight: '1.5',
                            textAlign: 'left',
                            maxWidth: '400px',
                            zIndex: 5,
                            fontFamily: match.fontFamily_label_2 || (FONT_STACK_MIXED_THAI_LATIN)
                          }}
                        >
                          {(() => {
                            if (Array.isArray(match.label_2)) {
                              return (
                                <>
                                  {match.label_2.map((line, index) => {
                                    // Check for risk level keywords in each line (both Thai and English)
                                    const keywordMatch = line.match(/(low|moderate|high)\s+(risk|vulnerability)|(เธฃเธฐเธ”เธฑเธเธ•เนเธณ|เธฃเธฐเธ”เธฑเธเธเธฒเธเธเธฅเธฒเธ|เธฃเธฐเธ”เธฑเธเธชเธนเธ)/i);
                                    if (keywordMatch) {
                                      const keyword = keywordMatch[0]; // e.g., "moderate vulnerability" or "เธฃเธฐเธ”เธฑเธเธเธฒเธเธเธฅเธฒเธ"
                                      const highlighted = line.replace(
                                        new RegExp(`(${keyword})`, 'i'),
                                        '<span style="font-weight:700;">$1</span>'
                                      );
                                      return (
                                        <div 
                                          key={index} 
                                          style={{ textIndent: index === 0 ? '40px' : '0px' }}
                                          dangerouslySetInnerHTML={{ __html: highlighted }}
                                        />
                                      );
                                    }
                                    return <div key={index} style={{ textIndent: index === 0 ? '40px' : '0px' }}>{line}</div>;
                                  })}
                                </>
                              );
                            }
                            
                            // Handle single string format
                            const keywordMatch = match.label_2.match(/(low|moderate|high)\s+(risk|vulnerability)|(เธฃเธฐเธ”เธฑเธเธ•เนเธณ|เธฃเธฐเธ”เธฑเธเธเธฒเธเธเธฅเธฒเธ|เธฃเธฐเธ”เธฑเธเธชเธนเธ)/i);
                            if (keywordMatch) {
                              const keyword = keywordMatch[0]; // e.g., "moderate vulnerability" or "เธฃเธฐเธ”เธฑเธเธเธฒเธเธเธฅเธฒเธ"
                              const highlighted = match.label_2.replace(
                                new RegExp(`(${keyword})`, 'i'),
                                '<span style="font-weight:700;">$1</span>'
                              );
                              return (
                                <div
                                  style={{ textIndent: '40px' }}
                                  dangerouslySetInnerHTML={{ __html: highlighted }}
                                />
                              );
                            }
                            return <div style={{ textIndent: '40px' }}>{match.label_2}</div>;
                          })()}
                        </div>
                      )}
                    </React.Fragment>
                  );
                })}

                {(reportMode === '9P' 
                  ? choosing_supplement_9P 
                  : reportMode === 'oms'
                  ? choosing_supplement_oms
                  : reportMode === 'Allergy and Skin'
                  ? choosing_supplement_AMG
                  : reportMode === 'Allergy and Skin_kids'
                  ? qpt_choosing_supplement
                  : reportMode === 'Toxin'
                  ? choosing_supplement_toxin
                  : reportMode === 'bwcallergy' || reportMode === 'bwccore'
                  ? choosing_supplement_bwc
                  : reportMode === 'bwcdiamond'
                  ? choosing_supplement_bwcdiamond
                  : qpt_choosing_supplement).map((config, i) => {
                  // Check if current page matches the configured page for the current language
                  // AMG config now has 'page_eng'/'page_thai' properties
                  const configPage = useThaiVersion ? config.page_thai : config.page_eng;
                  if (configPage !== pageNumber) return null;

                  // New formula: the same 3x3 grid the overflow pages use, fed
                  // from the canonical list โ€” chunk 0 is this page's slice, so it
                  // is already filtered and capped at MAX_9P_SUPPLEMENTS.
                  if (isNewFormula) {
                    return render9PSupplementGrid(supplementsForChunk(0), config, `page-${i}`);
                  }

                  // Use selectedSupplements if provided, otherwise recommendedSupplements
                  const baseSupplements = selectedSupplements.length > 0 ? selectedSupplements : recommendedSupplements;

                  // 9P original formula auto-adds BioGrace for age 45+.
                  const supplementsToShow = reportMode === '9P'
                    ? addBioGraceIfNeeded_old(baseSupplements, formData?.['Date of Birth'])
                    : baseSupplements;
                  if (!supplementsToShow.length) return null;

                  // Show the original formula's flat supplement images on the
                  // configured page.
                  if (reportMode === 'QPT' || reportMode === 'Allergy and Skin' || reportMode === 'Allergy and Skin_kids' || reportMode === 'Toxin' || reportMode === '9P' || reportMode === 'oms') {
                    const supplement_images = getSupplementImages(reportMode, useThaiVersion, supplement9PVersion);

                    // Debug logging for QA format
                    if (reportMode === 'Allergy and Skin') {
                      console.log('=== QA SUPPLEMENT DEBUG ===');
                      console.log('Page:', pageNumber, 'Thai:', useThaiVersion);
                      console.log('Supplements:', supplementsToShow);
                      console.log('Image Config:', supplement_images);
                    }

                    return (
                      <div
                        key={`supplement-imgs-${i}`}
                        style={{
                          position: 'absolute',
                          top: `${config.Ypos_text}px`,
                          left: `${config.Xpos_text}px`,
                          display: 'flex',
                          flexDirection: 'column',
                          gap: '15px',
                          zIndex: 5
                        }}
                      >
                        {supplementsToShow.map((supp, idx) => {
                          const imgConf = supplement_images[supp];
                          
                          // Debug logging for 9P supplements
                          if (reportMode === '9P') {
                            console.log(`=== 9P IMAGE DEBUG for ${supp} ===`);
                            console.log('Image Config:', imgConf);
                            console.log('Available images:', Object.keys(supplement_images));
                            console.log('CSV Preview Toggle (B2B):', csvPreviewToggle);
                            console.log('Use Thai Version:', useThaiVersion);
                          }
                          
                          // Debug logging for QA, QG, QM formats
                          if (reportMode === 'Allergy and Skin' || reportMode === 'Allergy and Skin_kids' || reportMode === 'Toxin' || reportMode === 'oms') {
                            console.log(`=== ${reportMode} SUPPLEMENT IMAGE DEBUG ===`);
                            console.log('Supplement name:', supp);
                            console.log('Available image configs:', Object.keys(supplement_images));
                            console.log('Found image config:', imgConf);
                          }
                          
                          if (!imgConf) {
                            console.warn(`No image config found for supplement: ${supp}`);
                            return null;
                          }

                                                      const imageName = getSupplementImageName(supp, reportMode, csvPreviewToggle, useThaiVersion);
                            
                            // Debug logging for all formats
                            console.log(`=== IMAGE NAME DEBUG for ${supp} ===`);
                            console.log('Supplement:', supp);
                            console.log('Report Mode:', reportMode);
                            console.log('CSV Preview Toggle (B2B):', csvPreviewToggle);
                            console.log('Use Thai Version:', useThaiVersion);
                            console.log('Generated image name:', imageName);
                            console.log('Full image path:', `/supplement/${imageName}.png`);
                            
                            // Special debug for BioGrace
                            if (supp === 'BioGrace') {
                              console.log('=== BIOGRACE IMAGE DEBUG ===');
                              console.log('BioGrace supplement detected!');
                              console.log('Expected image name should be:', useThaiVersion ? 'biograce_thai' : 'biograce');
                              console.log('Actual image name generated:', imageName);
                              console.log('Report Mode:', reportMode);
                              console.log('CSV Preview Toggle:', csvPreviewToggle);
                              console.log('Use Thai Version:', useThaiVersion);
                              console.log('Full image path:', `/supplement/${imageName}.png`);
                            }
                            
                            return (
                              <div key={supp} style={{ position: 'relative' }}>
                                <img
                                  src={`/supplement/${imageName}.png`}
                                  alt={supp}
                                  style={{
                                    // Non-9P panels keep their configured image
                                    // dimensions (9P renders cards above, not here).
                                    width: imgConf.width,
                                    height: imgConf.height,
                                    objectFit: 'contain',
                                    display: 'block'
                                  }}
                                  onError={(e) => {
                                    console.error(`Failed to load image: /supplement/${getSupplementImageName(supp, reportMode, csvPreviewToggle, useThaiVersion)}.png`);
                                    console.error(`Image path attempted: /supplement/${imageName}.png`);
                                    console.error(`Supplement: ${supp}, Report Mode: ${reportMode}, CSV Toggle: ${csvPreviewToggle}, Thai: ${useThaiVersion}`);
                                    
                                    // For BioGrace, try alternative image names
                                    if (supp === 'BioGrace') {
                                      console.log('Trying alternative BioGrace image paths...');
                                      const alternatives = [
                                        '/supplement/biograce.png',
                                        '/supplement/biograce_thai.png',
                                        '/supplement/BioGrace.png',
                                        '/supplement/BioGrace_thai.png'
                                      ];
                                      
                                      // Try the first alternative
                                      e.target.src = alternatives[0];
                                      e.target.onError = () => {
                                        console.error('All BioGrace image alternatives failed');
                                        e.target.style.display = 'none';
                                      };
                                    } else {
                                      e.target.style.display = 'none';
                                    }
                                  }}
                                  onLoad={() => {
                                    console.log(`Successfully loaded image: /supplement/${getSupplementImageName(supp, reportMode, csvPreviewToggle, useThaiVersion)}.png`);
                                  }}
                                />
                                {/* Static "Instruction of Use:" caption overlaid on the banner */}
                                {imgConf.text && supp !== 'BioGrace' && (
                                  <div
                                    className="supplement-label"
                                    style={{
                                      position: 'absolute',
                                      left: `${imgConf.text.x - imgConf.x}px`,
                                      top: `${imgConf.text.y - imgConf.y}px`,
                                      fontSize: `${imgConf.text.fontSize || 14}px`,
                                      fontWeight: imgConf.text.fontWeight || 'normal',
                                      fontFamily: imgConf.text.fontFamily || (FONT_STACK_MIXED_THAI_LATIN),
                                      color: imgConf.text.color || '#333333',
                                      zIndex: 10,
                                      textAlign: 'left',
                                      maxWidth: imgConf.width,
                                      lineHeight: '1.4'
                                    }}
                                  >
                                    {imgConf.text.content}
                                  </div>
                                )}
                                
                                {/* Dynamic dosing text overlaid next to the label (9P) */}
                                {reportMode === '9P' && imgConf.text && supp !== 'BioGrace' && (
                                  <div
                                    style={{
                                      position: 'absolute',
                                      left: `${(imgConf.text.x - imgConf.x) + (useThaiVersion ? 75 : 115)}px`,
                                      top: `${(imgConf.text.y - imgConf.y)}px`,
                                      fontSize: `${(imgConf.text.fontSize || 14) - 1}px`,
                                      fontWeight: imgConf.text.fontWeight || 'normal',
                                      fontFamily: imgConf.text.fontFamily || (FONT_STACK_MIXED_THAI_LATIN),
                                      color: imgConf.text.color || '#333333',
                                      textAlign: 'left',
                                      maxWidth: imgConf.width - 120,
                                      lineHeight: '1.3',
                                      whiteSpace: 'pre-line',
                                      zIndex: 20,
                                      backgroundColor: 'rgba(255, 255, 255, 0.9)',
                                      padding: '2px 4px',
                                      borderRadius: '2px'
                                    }}
                                  >
                                    {(() => {
                                      const { getSupplementInstruction } = require('../../configs/supplement/9P_supplement');
                                      const selectedSupplements = supplementsToShow || [];
                                      const durationValue = duration || formData?.duration || null;
                                      const instruction = getSupplementInstruction(
                                        selectedSupplements,
                                        durationValue,
                                        supp,
                                        csvPreviewToggle,
                                        useThaiVersion,
                                        formData?.['Date of Birth']
                                      );
                                      return instruction && instruction.trim().length > 0 ? instruction : '';
                                    })()}
                                  </div>
                                )}
                              </div>
                            );
                        })}
                      </div>
                    );
                  }
                  // Only render text if not QPT/31 or 9P/10
                  return (
                    <div
                      key={`supplement-${i}`}
                      className="pdf-overlay-text"
                      style={{
                        position: 'absolute',
                        top: `${config.Ypos_text}px`,
                        left: `${config.Xpos_text}px`,
                        fontSize: '14px',
                        fontWeight: 500,
                        color: '#000',
                        lineHeight: '1.5',
                        fontFamily: FONT_STACK_MIXED_THAI_LATIN,
                        maxWidth: '500px',
                        zIndex: 5
                      }}
                    >
                      {supplementsToShow.join(', ')}
                    </div>
                  );
                })}

                {/* Deficient Bacteria Text Display */}
                {(reportMode === 'QPT' || reportMode === 'Allergy and Skin' || reportMode === 'Allergy and Skin_kids' || reportMode === 'Toxin' || reportMode === 'bwcdiamond' || reportMode === 'bwcallergy' || reportMode === 'bwccore' || reportMode === '9P' || reportMode === 'oms') && (() => {
                  // Get the appropriate configuration based on report mode
                  const { pdfTextPreciseConfig, getDeficientBacteriaNames, formatBacteriaNames } = getPreciseTextHelpers(reportMode);
                  
                  // Debug logging for BWC Core format
                  if (reportMode === 'bwccore') {
                    console.log('๐” BWC Core - Text Display Debug:', {
                      reportMode,
                      pdfTextPreciseConfig: pdfTextPreciseConfig === pdfTextPreciseConfig_bwccore ? 'BWC Core Config' : 'Other Config',
                      getDeficientBacteriaNames: getDeficientBacteriaNames === getDeficientBacteriaNamesBwccore ? 'BWC Core Function' : 'Other Function',
                      formatBacteriaNames: formatBacteriaNames === formatBacteriaNamesBwccore ? 'BWC Core Function' : 'Other Function'
                    });
                  }
                  
                  // Get all configurations for the current page and language
                  const allConfigs = pdfTextPreciseConfig.beneficial_bacteria_deficiency.filter(
                    config => config.page === pageNumber && config.version === (useThaiVersion ? 'thai' : 'eng')
                  );
                  
                  if (allConfigs.length === 0) return null;

                  // Create a proper bacteria results structure for the helper function
                  const bacteriaResults = {};
                  const allBacteriaTypes = ['beneficial_bacteria', 'core_bacteria', 'harmful_bacteria'];
                  
                  allBacteriaTypes.forEach(bacteriaType => {
                    const bacteriaList = getTypeofBacteriaQpt(reportMode)[bacteriaType] || [];
                    
                    bacteriaList.forEach(bacteriaName => {
                      const score = scores[bacteriaName];
                      const value = results[bacteriaName];
                      
                      if (score !== undefined && value !== undefined) {
                        // Get the meta config to find the label
                        const metaSource = getActiveBacteriaMetaConfig();
                        const meta = metaSource[bacteriaName];
                        
                        if (meta && Array.isArray(meta.rangeMapping)) {
                          let matched;
                          if (meta.customCondition) {
                            const calc = parseFloat(value);
                            matched = meta.rangeMapping.find(r => 
                              typeof r.condition === 'function' && evaluateBacteriaCondition(r.condition, calc, formData, bacteriaName)
                            );
                          } else {
                            const calc = parseFloat(value);
                            matched = meta.rangeMapping.find(r => calc >= r.min && calc <= r.max);
                          }
                          
                          if (matched) {
                            bacteriaResults[bacteriaName] = {
                              label: matched.label,
                              score: matched.score_cal,
                              value: value,
                              type: bacteriaType
                            };
                          }
                        }
                      }
                    });
                  });

                  // Render text for each configuration that has deficient bacteria
                  return allConfigs.map((textConfig, index) => {
                    // Get deficient bacteria for this specific type with the correct target labels
                    const deficientBacteria = getDeficientBacteriaNames(bacteriaResults, textConfig.condition, textConfig.target_labels);
                    if (deficientBacteria.length === 0) return null;

                    // Format the bacteria names for display
                    const bacteriaText = formatBacteriaNames(deficientBacteria);
                    
                    // Debug logging for BWC Core format
                    if (reportMode === 'bwccore') {
                      console.log('๐” BWC Core - Text Rendering:', {
                        textConfig,
                        deficientBacteria,
                        bacteriaText,
                        bacteriaResults: Object.keys(bacteriaResults),
                        bacteriaResultsDetails: bacteriaResults
                      });
                    }
                    
                    return (
                      <div
                        key={`deficient-bacteria-${index}`}
                        className="pdf-overlay-text"
                        style={{
                          position: 'absolute',
                          top: `${textConfig.Ypostext}px`,
                          left: `${textConfig.Xpostext}px`,
                          fontSize: `${textConfig.fontsize}px`,
                          fontWeight: 400,
                          fontStyle: 'italic',
                          color: '#333',
                          lineHeight: '1.5',
                          textAlign: 'left',
                          maxWidth: `${textConfig.maxWidth}px`,
                          width: `${textConfig.maxWidth}px`,
                          wordWrap: 'break-word',
                          overflowWrap: 'break-word',
                          whiteSpace: 'pre-wrap',
                          zIndex: 5,
                          fontFamily: FONT_STACK_MIXED_THAI_LATIN
                        }}
                      >
                        <div style={{ fontWeight: 600, marginBottom: '5px' }}>
                          {textConfig.description}
                        </div>
                        <div>
                          {bacteriaText}
                        </div>
                      </div>
                    );
                  });
                })()}

                {Object.entries(activeOverlayConfig).map(([label, config]) => {
                  if (config.page !== pageNumber) return null;
                
                  // console.log(`[overlay] label: ${label} | value:`, formData[label]);
                  let value;

                  if (label === 'Report Date') {
                    value = formatReportDate(formData[label], useThaiVersion);
                  } else if (label === 'Order Number') {
                    // DB column is 'Report number' (lowercase n); guard against the legacy 'Report Number' key too
                    const reportNum = formData['Report number'] || formData['Report Number'] || formData['report_number'];
                    value = reportNum ? String(reportNum).substring(0, 8) : '-';
                  } else if (label === 'Report Number') {
                    // Overlay key is 'Report Number' but the DB column is 'Report number' โ€” read the real column
                    value = formData['Report number'] || formData['Report Number'] || formData['report_number'] || 'N/A';
                  } else if (label === 'Date of Birth' || label === 'Collection Date') {
                    const rawDate = formData[label];

                  if (useThaiVersion) {
                    const parsedDate = parseFlexibleDDMMYYYY(rawDate);
                    value = parsedDate
                      ? formatDateThai(parsedDate)
                      : 'N/A';
                  } else {
                    const parsedDate = parseFlexibleDDMMYYYY(rawDate);
                    value = parsedDate
                      ? parsedDate.toLocaleDateString('en-GB', {
                          day: 'numeric',
                          month: 'long',
                          year: 'numeric'
                        })
                      : 'N/A';
                  }
                  } else if (label === 'Gender' && useThaiVersion) {
                    value = translateGender(formData[label]);
                  } else if (label === 'HN') {
                    // Optional field — only the BWC CSVs carry it and the reports
                    // that predate it have none — so it hides when empty instead
                    // of printing N/A, the same as the every-page HN line does.
                    // (cleanReportData turns a blank cell into 0 on the way to
                    // the DB, and history hands back NULL; treat all as empty.)
                    const hn = formData['HN'];
                    value = hn === undefined || hn === null || hn === 0 || String(hn).trim() === ''
                      ? ''
                      : String(hn).trim();
                  } else {
                    value = formData[label] || 'N/A';
                  }                        
                
                  if (!value) return null;
                
                  return (
                    <div
                      key={label}
                      /* is-bold: the stylesheet forces overlay text to 400
                         !important and the server print CSS forces `inherit`
                         on inline weights, so an inline fontWeight alone never
                         renders bold. The class carries a 700 !important rule
                         at higher specificity (PdfStaticModal.css). */
                      className={`pdf-overlay-text${/^(bold|[6-9]00)$/.test(String(config.fontWeight || '')) ? ' is-bold' : ''}`}
                      style={{
                        top: config.y,
                        left: config.x,
                        position: 'absolute',
                        fontSize: config.fontSize,
                        fontFamily: FONT_STACK_MIXED_THAI_LATIN,
                        color: config.color,
                        fontWeight: config.fontWeight || 'normal'
                      }}
                    >
                      {value}
                    </div>
                  );
              })}

                {/* Overall Scoring Level Display - Show based on configuration */}
                {scoringFunctions.shouldShowScoringLevel(pageNumber, totalPages, useThaiVersion) && scoringLevel && (
                  <React.Fragment>
                    {/* Get display config once for the entire scoring level section */}
                    {(() => {
                      const displayConfig = scoringFunctions.getScoringDisplayConfig(useThaiVersion);
                      console.log('๐” DisplayConfig fontFamily:', displayConfig.position.description.fontFamily);
                       
                      return (
                        <>
                          {/* Scoring Level Image */}
                          {(() => {
                            const imagePath = `/status_classify/${useThaiVersion ? 'thai' : 'eng'}/${scoringLevel.img}.png`;
                            console.log('Scoring Level Image Path:', imagePath);
                            console.log('Scoring Level:', scoringLevel);
                            return (
                              <img
                                src={`${process.env.PUBLIC_URL}${imagePath}`}
                                alt={scoringLevel.label}
                                className="pdf-overlay-image"
                                style={{
                                  position: 'absolute',
                                  top: displayConfig.position.image.top,
                                  left: displayConfig.position.image.left,
                                  width: displayConfig.position.image.width,
                                  height: 'auto',
                                  zIndex: 5
                                }}
                                onError={(e) => {
                                  console.error('Failed to load image:', imagePath);
                                  e.target.style.display = 'none';
                                }}
                              />
                            );
                          })()}
                          
                          {/* Scoring Level Label */}
                          <div
                            className="pdf-overlay-text"
                            style={{
                              position: 'absolute',
                              top: '420px',
                              left: '50px',
                              fontSize: '24px',
                              fontWeight: 700,
                              color: scoringLevel.color,
                              textAlign: 'center',
                              width: '200px',
                              zIndex: 5,
                              fontFamily: FONT_STACK_MIXED_THAI_LATIN
                            }}
                          >
                            {scoringLevel.label}
                          </div>

                          {/* Overall Score Value */}
                          <div
                            className="pdf-overlay-text"
                            style={{
                              position: 'absolute',
                              top: '460px',
                              left: '50px',
                              fontSize: '18px',
                              fontWeight: 500,
                              color: '#333',
                              textAlign: 'center',
                              width: '200px',
                              zIndex: 5,
                              fontFamily: FONT_STACK_MIXED_THAI_LATIN
                            }}
                          >
                            {/* {useThaiVersion ? `เธเธฐเนเธเธเธฃเธงเธก: ${overallScore}` : `Overall Score: ${overallScore}`} */}
                          </div>

                          {/* Scoring Level Description */}
                          <div
                            className="pdf-overlay-text"
                            style={{
                              position: 'absolute',
                              top: displayConfig.position.description.top,
                              left: displayConfig.position.description.left,
                              fontSize: displayConfig.position.description.fontSize,
                              fontWeight: displayConfig.position.description.fontWeight,
                              color: '#333',
                              textAlign: 'center',
                              width: displayConfig.position.description.width,
                              lineHeight: '1.4',
                              zIndex: 5,
                              fontFamily: displayConfig.position.description.fontFamily || scoringLevel.fontFamily || (FONT_STACK_MIXED_THAI_LATIN)
                            }}
                            dangerouslySetInnerHTML={{ __html: scoringLevel.description }}
                          />

                          {/* Scoring Level Description 2 */}
                          <div
                            className="pdf-overlay-text"
                            style={{
                              position: 'absolute',
                              top: displayConfig.position.description_2.top,
                              left: displayConfig.position.description_2.left,
                              fontSize: displayConfig.position.description_2.fontSize,
                              fontWeight: displayConfig.position.description_2.fontWeight,
                              color: '#333',
                              textAlign: 'center',
                              width: displayConfig.position.description_2.width,
                              lineHeight: '1.4',
                              zIndex: 5,
                              fontFamily: displayConfig.position.description_2.fontFamily || scoringLevel.fontFamily_2 || (FONT_STACK_MIXED_THAI_LATIN)
                            }}
                          >
                            {scoringLevel.description_2}
                          </div>
                        </>
                      );
                    })()}
                  </React.Fragment>
                )}

                    {combinedBarConfig
                      .filter(bac => bac.page === pageNumber && ['bar_color', 'bar_colorlow'].includes(bac.format))
                      .map((bac, index) => {
                        const score = scores[bac.label];
                        const value = results[bac.label];

                      return (
                        <React.Fragment key={`${bac.label}-${pageNumber}-${index}`}>
                          <div
                              className="pdf-overlay-text text_slash"
                              style={{ top: bac.yLabel || bac.yOffset, left: bac.xLabel, position: 'absolute', fontFamily: FONT_STACK_MIXED_THAI_LATIN }}
                          >
                              {bac.title_label}
                          </div>

                          {[1, 2, 3, 4, 5].map(s => {
                            const barLeft = bac.xBarStart + bac.xBarGap * (s - 1);
                            // The score value (1-5) should directly match the block position (1-5)
                            const isMatch = score === s;
                            
                            // console.log(`Bar rendering for ${bac.label}:`, {
                            //   blockPosition: s,
                            //   currentScore: score,
                            //   isMatch
                            // });

                            // Dynamic arrow position
                            let arrowLeft = null;   

                            if (isMatch) {
                              arrowLeft = barLeft + bac.xBarGap / 2;
                            }

                            return (
                              <div
                                key={s}
                                className={`score-block score-${s} ${isMatch ? 'active' : ''} ${bac.format === 'bar_colorlow' ? 'lowbar' : ''}`}
                                style={{
                                  top: bac.yOffset,
                                  left: barLeft,
                                  position: 'absolute'
                                }}
                              >
                                {isMatch && arrowLeft !== null && (
                                  <div
                                    className="arrow-down"
                                    style={{
                                      position: 'absolute',
                                      left: `${arrowLeft - barLeft}px`, // relative to this block
                                      top: '-7px'
                                    }}
                                  />
                                )}
                              </div>
                            );
                          })}

                        {(bac.show_result === undefined || bac.show_result === true) && value && (
                          <div
                            className="pdf-overlay-text text_reulst"
                            style={{
                              top: bac.yResult || bac.yOffset,
                              left: bac.xResult,
                              position: 'absolute',
                              fontFamily: FONT_STACK_MIXED_THAI_LATIN
                            }}
                          >
                            {parseFloat(value) >= 35 ? `{ ≥35 }` : `{ ${value} }`}
                          </div>
                        )}
                          <div
                            className="pdf-overlay-text text_score_label text_al"
                            style={{
                              top: useThaiVersion
                                ? (scoreLabelPositionThai[bac.label]?.y ?? bac.yResulttext)
                                : (bac.scoreLabelY ?? bac.yResulttext),

                              left: useThaiVersion
                                ? (scoreLabelPositionThai[bac.label]?.x ?? bac.xResulttext)
                                : (bac.scoreLabelX ?? bac.xResulttext),

                              position: 'absolute',
                              fontSize: 12,
                              fontWeight: 'normal',
                              color: '#333',
                              textAlign: 'left',
                              width: '70px',
                              fontFamily: FONT_STACK_MIXED_THAI_LATIN
                            }}
                          >
                            {useThaiVersion
                              ? (scoreLabelMappingThai[bac.label]?.[score] || '')
                              : (bac.rangeMapping.find(r => r.score === score)?.label || '')
                            }
                          </div>
                          </React.Fragment>
                        );
                    })}

                    {/* Vitamin B Bar Rendering - Only for QPT format */}
                    {reportMode === 'QPT' && Object.keys(vitaminB_spCondition).map((vitamin) => {
                      // Use Thai config if Thai version is selected, otherwise use English config
                      const config = useThaiVersion 
                        ? (vitaminB_spCondition_thai[vitamin] || vitaminB_spCondition[vitamin])
                        : vitaminB_spCondition[vitamin];
                      
                      if (!config || config.page !== pageNumber) return null;

                      const score = vitaminBScores[vitamin];
                      const result = vitaminBResults[vitamin];
                      const matchedCondition = config.conditions.find(c => c.condition(parseFloat(result || 0)));

                      return (
                        <React.Fragment key={`vitamin-${vitamin}-${pageNumber}`}>
                          {/* Vitamin Label - Show the matched condition label */}
                          {matchedCondition && (
                            <div
                              className="pdf-overlay-text"
                              style={{
                                top: config.YposText,
                                left: config.XposText,
                                position: 'absolute',
                                fontFamily: FONT_STACK_MIXED_THAI_LATIN,
                                fontStyle: 'normal',
                                color: '#000000',
                                textAlign: 'left',
                                fontSize: useThaiVersion ? '17px' : '15px'
                              }}
                            >
                              {matchedCondition.label}
                            </div>
                          )}

                          {/* 5 Bars - Focus on bars 1, 2, 3 with labels */}
                          {[1, 2, 3, 4, 5].map(s => {
                            const barLeft = config.xBarStart + config.xBarGap * (s - 1);
                            const isMatch = score === s;
                            // eslint-disable-next-line no-unused-vars
                            const _isFocused = s <= 3; // Focus on bars 1, 2, 3

                            let arrowLeft = null;
                            if (isMatch) {
                              arrowLeft = barLeft + config.xBarGap / 2;
                            }

                            return (
                              <div
                                key={s}
                                className={`score-block score-${s} ${isMatch ? 'active' : ''}`}
                                style={{
                                  top: config.YBarStart || config.yOffset,
                                  left: barLeft,
                                  position: 'absolute',
                                  width: '60px'
                                }}
                              >
                                {isMatch && arrowLeft !== null && (
                                  <div
                                    className="arrow-down"
                                    style={{
                                      position: 'absolute',
                                      left: `${arrowLeft - barLeft}px`,
                                      top: '-7px'
                                    }}
                                  />
                                )}
                              </div>
                            );
                          })}

                          {/* Vitamin B Image */}
                          {matchedCondition && (
                            <img
                              src={`${process.env.PUBLIC_URL}/vitb/${matchedCondition.image}.png`}
                              alt={`${vitamin} ${matchedCondition.label}`}
                              className="pdf-overlay-image"
                              style={{
                                position: 'absolute',
                                top: config.YposImage,
                                left: config.XposImage,
                                width: config.scale_imageX,
                                height: config.scale_imageY,
                                zIndex: 5
                              }}
                              onError={(e) => {
                                console.error('Failed to load vitamin B image:', `/vitb/${matchedCondition.image}.png`);
                                e.target.style.display = 'none';
                              }}
                            />
                          )}
                        </React.Fragment>
                      );
                    })}

                    {/* Neurotransmitter Bar Rendering - Only for QPT format */}
                    {reportMode === 'QPT' && Object.keys(neurotransmitter_spCondition).map((neurotransmitter) => {
                      // Use Thai config if Thai version is selected, otherwise use English config
                      const config = useThaiVersion 
                        ? (neurotransmitter_spCondition_thai[neurotransmitter] || neurotransmitter_spCondition[neurotransmitter])
                        : neurotransmitter_spCondition[neurotransmitter];
                      
                      if (!config || config.page !== pageNumber) return null;

                      const score = neurotransmitterScores[neurotransmitter];
                      const result = neurotransmitterResults[neurotransmitter];
                      const matchedCondition = config.conditions.find(c => c.condition(parseFloat(result || 0)));

                      return (
                        <React.Fragment key={`neurotransmitter-${neurotransmitter}-${pageNumber}`}>
                          {/* Neurotransmitter Label - Show the matched condition label */}
                          {matchedCondition && (
                            <div
                              className="pdf-overlay-text"
                              style={{
                                top: config.YposText,
                                left: config.XposText,
                                position: 'absolute',
                                fontFamily: FONT_STACK_MIXED_THAI_LATIN,
                                fontStyle: 'normal',
                                color: '#000000',
                                textAlign: 'left',
                                fontSize: useThaiVersion ? '17px' : '15px'
                              }}
                            >
                              {matchedCondition.label}
                            </div>
                          )}

                          {/* 5 Bars - Focus on bars 1, 2, 3 with labels */}
                          {[1, 2, 3, 4, 5].map(s => {
                            const barLeft = config.xBarStart + config.xBarGap * (s - 1);
                            const isMatch = score === s;
                            // eslint-disable-next-line no-unused-vars
                            const _isFocused = s <= 3; // Focus on bars 1, 2, 3

                            let arrowLeft = null;
                            if (isMatch) {
                              arrowLeft = barLeft + config.xBarGap / 2;
                            }

                            return (
                              <div
                                key={s}
                                className={`score-block score-${s} ${isMatch ? 'active' : ''}`}
                                style={{
                                  top: config.YBarStart || config.yOffset,
                                  left: barLeft,
                                  position: 'absolute',
                                  width: '60px'
                                }}
                              >
                                {isMatch && arrowLeft !== null && (
                                  <div
                                    className="arrow-down"
                                    style={{
                                      position: 'absolute',
                                      left: `${arrowLeft - barLeft}px`,
                                      top: '-7px'
                                    }}
                                  />
                                )}
                              </div>
                            );
                          })}

                          {/* Neurotransmitter Image */}
                          {matchedCondition && (
                            <img
                              src={`${process.env.PUBLIC_URL}/neuro/${matchedCondition.image}.png`}
                              alt={`${neurotransmitter} ${matchedCondition.label}`}
                              className="pdf-overlay-image"
                              style={{
                                position: 'absolute',
                                top: config.YposImage,
                                left: config.XposImage,
                                width: config.scale_imageX,
                                height: config.scale_imageY,
                                zIndex: 5
                              }}
                              onError={(e) => {
                                console.error('Failed to load neurotransmitter image:', `/neuro/${matchedCondition.image}.png`);
                                e.target.style.display = 'none';
                              }}
                            />
                          )}
                        </React.Fragment>
                      );
                    })}

                    {/* Metabolites Bar Rendering - Only for QPT format */}
                    {reportMode === 'QPT' && Object.keys(metabolites_spCondition).map((metabolite) => {
                      // Use Thai config if Thai version is selected, otherwise use English config
                      const config = useThaiVersion 
                        ? (metabolites_spCondition_thai[metabolite] || metabolites_spCondition[metabolite])
                        : metabolites_spCondition[metabolite];
                      
                      if (!config || config.page !== pageNumber) return null;

                      const score = metabolitesScores[metabolite];
                      const result = metabolitesResults[metabolite];
                      const matchedCondition = config.conditions.find(c => c.condition(parseFloat(result || 0)));

                      return (
                        <React.Fragment key={`metabolite-${metabolite}-${pageNumber}`}>
                          {/* Metabolite Label - Show the matched condition label */}
                          {matchedCondition && (
                            <div
                              className="pdf-overlay-text"
                              style={{
                                top: config.YposText,
                                left: config.XposText,
                                position: 'absolute',
                                fontFamily: FONT_STACK_MIXED_THAI_LATIN,
                                fontStyle: 'normal',
                                color: '#000000',
                                textAlign: 'left',
                                fontSize: useThaiVersion ? '17px' : '15px'
                              }}
                            >
                              {matchedCondition.label}
                            </div>
                          )}

                          {/* 5 Bars - Focus on bars 1, 2, 3 with labels */}
                          {[1, 2, 3, 4, 5].map(s => {
                            const barLeft = config.xBarStart + config.xBarGap * (s - 1);
                            const isMatch = score === s;
                            // eslint-disable-next-line no-unused-vars
                            const _isFocused = s <= 3; // Focus on bars 1, 2, 3

                            let arrowLeft = null;
                            if (isMatch) {
                              arrowLeft = barLeft + config.xBarGap / 2;
                            }

                            return (
                              <div
                                key={s}
                                className={`score-block score-${s} ${isMatch ? 'active' : ''}`}
                                style={{
                                  top: config.YBarStart || config.yOffset,
                                  left: barLeft,
                                  position: 'absolute',
                                  width: '60px'
                                }}
                              >
                                {isMatch && arrowLeft !== null && (
                                  <div
                                    className="arrow-down"
                                    style={{
                                      position: 'absolute',
                                      left: `${arrowLeft - barLeft}px`,
                                      top: '-7px'
                                    }}
                                  />
                                )}
                              </div>
                            );
                          })}

                          {/* Metabolite Image */}
                          {matchedCondition && (
                            <img
                              src={`${process.env.PUBLIC_URL}/metaboilites/${matchedCondition.image}.png`}
                              alt={`${metabolite} ${matchedCondition.label}`}
                              className="pdf-overlay-image"
                              style={{
                                position: 'absolute',
                                top: config.YposImage,
                                left: config.XposImage,
                                width: config.scale_imageX,
                                height: config.scale_imageY,
                                zIndex: 5
                              }}
                              onError={(e) => {
                                console.error('Failed to load metabolite image:', `/metaboilites/${matchedCondition.image}.png`);
                                e.target.style.display = 'none';
                              }}
                            />
                          )}
                        </React.Fragment>
                      );
                    })}

                    {/* Macronutrient Bar Rendering - Only for QPT format */}
                    {reportMode === 'QPT' && Object.keys(macronutrient_spCondition).map((macronutrient) => {
                      // Use Thai config if Thai version is selected, otherwise use English config
                      const config = useThaiVersion 
                        ? (macronutrient_spCondition_thai[macronutrient] || macronutrient_spCondition[macronutrient])
                        : macronutrient_spCondition[macronutrient];
                      
                      if (!config || config.page !== pageNumber) return null;

                      const score = macronutrientScores[macronutrient];
                      const result = macronutrientResults[macronutrient];
                      const matchedCondition = config.conditions.find(c => c.condition(parseFloat(result || 0)));

                      return (
                        <React.Fragment key={`macronutrient-${macronutrient}-${pageNumber}`}>
                          {/* Macronutrient Label - Show the matched condition label */}
                          {matchedCondition && (
                            <div
                              className="pdf-overlay-text"
                              style={{
                                top: config.YposText,
                                left: config.XposText,
                                position: 'absolute',
                                fontFamily: FONT_STACK_MIXED_THAI_LATIN,
                                fontStyle: 'normal',
                                color: '#000000',
                                textAlign: 'left',
                                fontSize: useThaiVersion ? '17px' : '15px'
                              }}
                            >
                              {matchedCondition.label}
                            </div>
                          )}

                          {/* 5 Bars - Focus on bars 1, 2, 3 with labels */}
                          {[1, 2, 3, 4, 5].map(s => {
                            const barLeft = config.xBarStart + config.xBarGap * (s - 1);
                            const isMatch = score === s;
                            // eslint-disable-next-line no-unused-vars
                            const _isFocused = s <= 3; // Focus on bars 1, 2, 3

                            let arrowLeft = null;
                            if (isMatch) {
                              arrowLeft = barLeft + config.xBarGap / 2;
                            }

                            return (
                              <div
                                key={s}
                                className={`score-block score-${s} ${isMatch ? 'active' : ''}`}
                                style={{
                                  top: config.YBarStart || config.yOffset,
                                  left: barLeft,
                                  position: 'absolute',
                                  width: '60px'
                                }}
                              >
                                {isMatch && arrowLeft !== null && (
                                  <div
                                    className="arrow-down"
                                    style={{
                                      position: 'absolute',
                                      left: `${arrowLeft - barLeft}px`,
                                      top: '-7px'
                                    }}
                                  />
                                )}
                              </div>
                            );
                          })}

                          {/* Macronutrient Image */}
                          {matchedCondition && (
                            <img
                              src={`${process.env.PUBLIC_URL}/macronutrient/${matchedCondition.image}.png`}
                              alt={`${macronutrient} ${matchedCondition.label}`}
                              className="pdf-overlay-image"
                              style={{
                                position: 'absolute',
                                top: config.YposImage,
                                left: config.XposImage,
                                width: config.scale_imageX,
                                height: config.scale_imageY,
                                zIndex: 5
                              }}
                              onError={(e) => {
                                console.error('Failed to load macronutrient image:', `/macronutrient/${matchedCondition.image}.png`);
                                e.target.style.display = 'none';
                              }}
                            />
                          )}
                        </React.Fragment>
                      );
                    })}
                  </div>
                );
            })}
          </div>

          {/* Quick Navigation โ€” jump to key pages without scrolling manually. */}
          {quickNavItems.length > 0 && (
            <div className="pdf-quick-nav">
              <div className="pdf-quick-nav__title">Quick Navigation</div>
              {quickNavItems.map((item) => {
                const targetPage = item.page;
                if (!targetPage || targetPage > totalPagesWithOverflow) return null;
                return (
                  <button
                    key={item.text}
                    type="button"
                    className="pdf-quick-nav__btn"
                    onClick={() => {
                      const target = document.getElementById(`pdf-preview-page-${targetPage}`);
                      if (target) {
                        target.scrollIntoView({ behavior: 'smooth', block: 'start' });
                      }
                    }}
                  >
                    {item.text}
                    <span className="pdf-quick-nav__page">p.{targetPage}</span>
                  </button>
                );
              })}
            </div>
          )}
          </div>

          <div className="pdf-button-group">
          {/* {reportMode !== '9P' && ( */}
            <button
              className="pdf-switch"
              onClick={onToggleLanguage}
              style={{
                marginRight: 'auto',
                backgroundColor: '#f1f1f1',
                color: '#333',
                padding: '8px 12px',
                borderRadius: '6px',
                border: '1px solid #ccc',
                cursor: 'pointer'
              }}
            >
              Switch to {useThaiVersion ? 'English' : 'Thai'}
            </button>
          {/* )} */}

            {/* <button className="pdf-download" onClick={handleSave}>Download</button> */}
            <button className="pdf-cancel" onClick={fromCsvPreview ? onBackToCsv : onClose}>Back</button>
          </div>
        </div>
      </div>
    );
  };

  export default PdfStaticModal;

